import React, { useState, useRef, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import validator from "validator";
import mammoth from "mammoth";
import HelpIcon from "@mui/icons-material/HelpOutline";
import ContentWrapper from "../../../../common/components/contentWrapper";
import { addInventoryImage } from "../actions/dealerAction";
import {
  Container,
  Grid,
  FormHelperText,
  FormControlLabel,
  FormControl,
  Checkbox,
  Typography,
  InputAdornment,
  Button,
  Input,
  MenuItem,
  Select,
  Divider,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import CloseIcon from "@mui/icons-material/Close";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CheckIcon from "@mui/icons-material/Check";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import MilitaryTechOutlinedIcon from "@mui/icons-material/MilitaryTechOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import { Popover as AntdPopover, Input as AntdInput } from "antd";
import Tooltip from "@mui/material/Tooltip";
import {
  addInventoryData,
  addMiscInventoryData,
  individualBrowseWatch,
  searchProducts,
  searchLocation,
} from "../actions/dealerAction";
import searchinventry from "../../dashboard/actions/dashboardaapi";
import _ from "lodash";
import { SpinnerRoundFilled } from "spinners-react";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  brandList,
  caseMaterial,
  brandMaterial,
} from "../../browse-watches/actions/browseWatchesActions";
import DateFnsUtils from "@date-io/date-fns";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import { List, ListItem, ListItemText, ListItemIcon, Dialog, DialogContent } from "@mui/material";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
import { toast } from "react-toastify";
import EditIcon from "@material-ui/icons/Edit";
import LimitReachedComponent from "../../subscription/LimitReachedComponent";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@material-ui/icons/Clear";
import {
  getComponentActionList,
  isActionAllowed,
  getComponentViewsList,
} from "../../../../common/components/Helper/Utils";
import { getCustomLabel } from "../../../../common/components/Helper/Utils";
import AccessRestricted from "../../common/components/accessRestricted";
import UpgradePlan from "../../common/components/upgradePlan";
import { getBusinessAccountIds } from "../../dashboard/actions/dashboardAction";
import "../../dashboard/style/createInventory.css";
import { event } from "jquery";

const getUsedGood = () => getCustomLabel("custom_used_good", "Used/Good");
const getMintVeryGood = () => getCustomLabel("custom_mint_verygood", "Mint/Very Good");
const getRetailReady = () => getCustomLabel("custom_retail_likenew", "Retail Ready/Like New");
const getNewCond = () => getCustomLabel("custom_new", "New");
const getUsed = () => getCustomLabel("custom_used", "Used");

const followersMarks1 = () => [
  { value: 1, scaledValue: 1, label: getUsedGood() },
  { value: 2, scaledValue: 2, label: getMintVeryGood() },
  { value: 3, scaledValue: 3, label: getRetailReady() },
  { value: 4, scaledValue: 4, label: getNewCond() },
];

const followersMarks2 = () => [
  { value: 1, scaledValue: 1, label: getNewCond() },
  { value: 2, scaledValue: 2, label: getUsed() },
];

const formatNumber = (num) => {
  if (!num) return "";
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const calculateTotalCost = (purchasePriceRaw, purchaseExpenseRaw) => {
  const purchasePrice = Number(purchasePriceRaw || 0);
  const purchaseExpense = Number(purchaseExpenseRaw || 0);
  const total = Number((purchasePrice + purchaseExpense).toFixed(2));
  return { raw: total, formatted: formatNumber(total) };
};

const formatCurrency = (value) => {
  if (value === null || value === undefined) return "";
  return Number(value).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const isValidDate = (date) => date instanceof Date && !isNaN(date);

const formatFileSize = (bytes) => {
  if (bytes === null || bytes === undefined) return "";
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
};

const formatDuration = (seconds) => {
  if (seconds === null || seconds === undefined || isNaN(seconds)) return "";
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${String(s).padStart(2, "0")}`;
};

const getVideoDuration = (file) =>
  new Promise((resolve) => {
    try {
      const videoEl = document.createElement("video");
      videoEl.preload = "metadata";
      videoEl.onloadedmetadata = () => {
        URL.revokeObjectURL(videoEl.src);
        resolve(videoEl.duration);
      };
      videoEl.onerror = () => resolve(null);
      videoEl.src = URL.createObjectURL(file);
    } catch (e) {
      resolve(null);
    }
  });

const fileExtension = (name = "") => {
  const idx = name.lastIndexOf(".");
  return idx >= 0 ? name.slice(idx + 1).toLowerCase() : "";
};

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp"];

const makeFileEntry = (file) => ({
  id: `${file.name}-${file.size}-${file.lastModified}-${Math.random().toString(36).slice(2)}`,
  file,
  url: URL.createObjectURL(file),
  name: file.name,
  size: file.size,
});

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

// -- "Add Inventory" layout building blocks --------------------------------
// Small presentational components only; no business logic lives here.
const SectionCard = ({ icon, title, children, style }) => (
  <div className="ai-section-card" style={style}>
    <div className="ai-section-card__header">
      <span className="ai-section-card__icon">{icon}</span>
      <Typography className="ai-section-card__title">{title}</Typography>
    </div>
    <div className="ai-section-card__body">{children}</div>
  </div>
);

const FieldLabel = ({ children, required }) => (
  <Typography className="ai-field-label">
    {children}
    {required ? <span className="ai-field-label__required"> *</span> : null}
  </Typography>
);

const CONDITION_COLORS = [
  { border: "#F0B25F", bg: "#FFF8EE" },
  { border: "#8FCB9B", bg: "#F2FBF3" },
  { border: "#7FA6E8", bg: "#F3F6FE" },
  { border: "#B98CE0", bg: "#FAF5FE" },
];

const CONDITION_ICONS = [
  LocalMallOutlinedIcon,
  MilitaryTechOutlinedIcon,
  ShoppingCartOutlinedIcon,
  CardGiftcardOutlinedIcon,
];

const ConditionSelector = ({ marks, value, onChange }) => (
  <div className="ai-condition-group">
    {marks.map((mark, idx) => {
      const color = CONDITION_COLORS[idx % CONDITION_COLORS.length];
      const Icon = CONDITION_ICONS[idx % CONDITION_ICONS.length];
      const selected = Number(value) === mark.value;
      return (
        <div
          key={mark.value}
          className={`ai-condition-card${selected ? " ai-condition-card--selected" : ""}`}
          style={{ borderColor: color.border, background: color.bg }}
          onClick={(e) => onChange(e, mark.value)}
        >
          {selected && (
            <span className="ai-condition-card__check" style={{ background: color.border }}>
              <CheckIcon style={{ fontSize: 12, color: "#fff" }} />
            </span>
          )}
          <Icon className="ai-condition-card__icon" style={{ color: color.border }} />
          <span className="ai-condition-card__label" style={{ color: color.border }}>{mark.label}</span>
        </div>
      );
    })}
  </div>
);

const UploadDropzone = ({ icon, title, hint, onFilesSelected, inputId, multiple = true, accept }) => {
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer?.files?.length) {
      onFilesSelected(e.dataTransfer.files);
    }
  };
  return (
    <div
      className="ai-dropzone"
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      onClick={() => document.getElementById(inputId)?.click()}
    >
      <input
        id={inputId}
        type="file"
        multiple={multiple}
        accept={accept}
        style={{ display: "none" }}
        onChange={(e) => {
          if (e.target.files?.length) onFilesSelected(e.target.files);
          e.target.value = "";
        }}
      />
      <div className="ai-dropzone__icon">{icon}</div>
      <Typography className="ai-dropzone__title">{title}</Typography>
      <Typography className="ai-dropzone__hint">{hint}</Typography>
    </div>
  );
};

const ImagePreviewGrid = ({ files, onRemove }) => {
  const [previewFile, setPreviewFile] = useState(null);
  return (
    <div className="ai-uploads__previews">
      {files.map((f) => (
        <div className="ai-uploads__thumb" key={f.id}>
          <img src={f.url} alt={f.name} onClick={() => setPreviewFile(f)} />
          <div className="ai-uploads__thumb-preview-overlay" onClick={() => setPreviewFile(f)}>
            <VisibilityOutlinedIcon style={{ fontSize: 18, color: "#fff" }} />
          </div>
          <button
            type="button"
            className="ai-uploads__thumb-remove"
            onClick={() => onRemove(f.id)}
            aria-label="Remove image"
          >
            <CloseIcon style={{ fontSize: 12 }} />
          </button>
        </div>
      ))}

      <Dialog open={!!previewFile} onClose={() => setPreviewFile(null)} maxWidth="md" fullWidth>
        <div className="ai-invoice-dialog__header">
          <Typography className="ai-invoice-dialog__title">{previewFile?.name}</Typography>
          <IconButton size="small" onClick={() => setPreviewFile(null)} aria-label="Close preview">
            <CloseIcon style={{ fontSize: 18 }} />
          </IconButton>
        </div>
        <DialogContent className="ai-invoice-dialog__content">
          {previewFile && (
            <img src={previewFile.url} alt={previewFile.name} className="ai-invoice-dialog__image" />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

const VideoPreviewGrid = ({ files, onRemove }) => (
  <div className="ai-uploads__previews">
    {files.map((f) => (
      <div className="ai-uploads__thumb ai-uploads__thumb--video" key={f.id}>
        <video src={f.url} muted playsInline preload="metadata" />
        <div className="ai-uploads__video-overlay">
          <PlayCircleOutlineIcon style={{ fontSize: 22, color: "#fff" }} />
        </div>
        {f.duration ? (
          <span className="ai-uploads__video-duration">{formatDuration(f.duration)}</span>
        ) : null}
        <button
          type="button"
          className="ai-uploads__thumb-remove"
          onClick={() => onRemove(f.id)}
          aria-label="Remove video"
        >
          <CloseIcon style={{ fontSize: 12 }} />
        </button>
      </div>
    ))}
  </div>
);

const InvoiceFilePreviewCard = ({ file, onReplace, onRemove, inputId, accept }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [docPreviewHtml, setDocPreviewHtml] = useState(null);
  const [docPreviewError, setDocPreviewError] = useState(false);
  const ext = fileExtension(file.name);
  const isImage = IMAGE_EXTENSIONS.includes(ext);
  const isPdf = ext === "pdf";

  useEffect(() => {
    setDocPreviewHtml(null);
    setDocPreviewError(false);
  }, [file.id]);

  useEffect(() => {
    if (previewOpen && ext === "docx" && !docPreviewHtml && !docPreviewError && file.file) {
      file.file
        .arrayBuffer()
        .then((buf) => mammoth.convertToHtml({ arrayBuffer: buf }))
        .then((res) => setDocPreviewHtml(res.value))
        .catch(() => setDocPreviewError(true));
    }
  }, [previewOpen, ext, file, docPreviewHtml, docPreviewError]);

  return (
    <div className="ai-invoice-preview">
      <input
        id={inputId}
        type="file"
        accept={accept}
        style={{ display: "none" }}
        onChange={(e) => {
          if (e.target.files?.length) onReplace(e.target.files);
          e.target.value = "";
        }}
      />
      <div className="ai-invoice-preview__thumb">
        {isImage ? (
          <img src={file.url} alt={file.name} />
        ) : (
          <InsertDriveFileOutlinedIcon style={{ color: isPdf ? "#e3574b" : "#3fa64d", fontSize: 32 }} />
        )}
      </div>
      <div className="ai-uploads__file-chip-info">
        <Typography className="ai-uploads__file-chip-name">{file.name}</Typography>
        {/* <Typography className="ai-uploads__file-chip-size">{formatFileSize(file.size)}</Typography> */}
        <Typography className="ai-uploads__file-chip-size">
          {formatFileSize(file.size)} · {ext.toUpperCase()}
        </Typography>
      </div>
      <div className="ai-invoice-preview__actions">
        <Tooltip title="Preview">
          <IconButton
            size="small"
            // disabled={ext === "doc" && !file.url.startsWith("http")}
            onClick={() => setPreviewOpen(true)}
            aria-label="Preview file"
          >
            <VisibilityOutlinedIcon style={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Replace">
          <IconButton
            size="small"
            onClick={() => document.getElementById(inputId)?.click()}
            aria-label="Replace file"
          >
            <EditIcon style={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton size="small" onClick={onRemove} aria-label="Delete file">
            <CloseIcon style={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </div>

      <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)} maxWidth="md" fullWidth>
        <div className="ai-invoice-dialog__header">
          <Typography className="ai-invoice-dialog__title">{file.name}</Typography>
          <IconButton size="small" onClick={() => setPreviewOpen(false)} aria-label="Close preview">
            <CloseIcon style={{ fontSize: 18 }} />
          </IconButton>
        </div>
        <DialogContent className="ai-invoice-dialog__content">
          {isImage ? (
            <img src={file.url} alt={file.name} className="ai-invoice-dialog__image" />
          ) : isPdf ? (
            <iframe src={file.url} title={file.name} className="ai-invoice-dialog__frame" />
          ) : ext === "docx" ? (
            docPreviewError ? (
              <Typography>
                Preview not available.{" "}
                <a href={file.url} target="_blank" rel="noopener noreferrer">
                  Download {file.name}
                </a>
              </Typography>
            ) : docPreviewHtml ? (
              <div
                style={{ padding: 16, overflow: "auto", maxHeight: "70vh" }}
                dangerouslySetInnerHTML={{ __html: docPreviewHtml }}
              />
            ) : (
              <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
                <CircularProgress size={24} />
              </div>
            )
          ) : ext === "doc" ? (
            file.url.startsWith("http") ? (
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(file.url)}`}
                title={file.name}
                className="ai-invoice-dialog__frame"
              />
            ) : (
              <Typography>
                Preview isn't available for .doc files before upload — the file needs
                a saved server URL for Office's viewer to open it.{" "}
                <a href={file.url} target="_blank" rel="noopener noreferrer">
                  Download {file.name}
                </a>
              </Typography>
            )
          ) : (
            <Typography>Preview isn't available for this file type.</Typography>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export const getNextMiscProductInventoryTitle = ({
  modelName = "",
  currentInventoryTitle = "",
  wasInventoryTitleManuallyCleared = false,
}) => {
  const normalizedModelName = typeof modelName === "string" ? modelName.trim() : "";
  if (!normalizedModelName) return "";
  if (wasInventoryTitleManuallyCleared) return currentInventoryTitle ?? "";
  return modelName;
};

const INITIAL_STATE = () => ({
  userData: sessionStorage.getItem("userDetails")
    ? JSON.parse(sessionStorage.getItem("userDetails"))
    : null,
  accountId: window.sessionStorage.getItem("accountId"),
  isShopifyEnabled: window.sessionStorage.getItem("isShopifyEnabled") === "true",
  isShopifyVerified: window.sessionStorage.getItem("isShopifyVerified") === "true",
  isQboVerified: window.sessionStorage.getItem("isQboVerified") === "true",
  isEbayEnabled: window.sessionStorage.getItem("isEbayEnabled") === "true",
  isEbayVerified: window.sessionStorage.getItem("isEbayVerified") === "true",
  accountIds: [],
  ModelNumber: "",
  PurchasedDate: "",
  PurchasedDate1: "",
  archiveDate: "",
  cursor: 0,
  PurchasedFrom: "",
  purchasedFromArray: [],
  purchaseFromContactId: null,
  dataset: [],
  isPopOverPurchasedFrom: false,
  isPopOverMemoDetails: false,
  isPopOverPartnershipDetails: false,
  PurchasedPrice: "",
  raw_PurchasedPrice: "",
  SerialNumber: "",
  InventoryType: "",
  inventory_type: "",
  MemoDetails: "",
  memoDetailsArray: [],
  memoContactId: null,
  PartnershipDetails: "",
  partnershipDetailsArray: [],
  partnerContactId: null,
  Condition: "1",
  BandSize: "",
  NumberOfLinks: "",
  raw_NumberOfLinks: "",
  DealerNotes: "",
  WholeSalePrice: "",
  raw_Wholesale_Price: "",
  RetailPrice: "",
  raw_Retail_Price: "",
  RetailWirePrice: "",
  raw_Retail_Wireprice: "",
  disbleseach: false,
  IndividualBrowseWatchesData: "",
  onModelNumberErrorText: "",
  onPurchasedDateErrorText: "",
  onPurchasedPriceErrorText: "",
  onSerialNumberErrorText: "",
  onSerialNumberMiscErrorText: "",
  onConditionErrorText: "",
  modificationDetailsError: "",
  onCoditionTenSuccessText: "",
  onBandSizeErrorText: "",
  onDealerNotesErrorText: "",
  onNumberOfLinksErrorText: "",
  onWholeSalePriceErrorText: "",
  onRetailPriceErrorText: "",
  onRetailWirePriceErrorText: "",
  onTagPriceErrorText: "",
  onPurchaseExpenseErrorText: "",
  onPurchaseExpenseNoteErrorText: "",
  onPublicDealerNoteErrorText: "",
  onInventoryStatusErrorText: "",
  onpaymentDateErrorText: "",
  individualsearchdata: false,
  autocomplete: { currentInput: "", loading: false, data: [] },
  selectedProduct: { productId: "" },
  selected: { product: null },
  loaded: false,
  typeOfPaper: null,
  limitReachedModalOpen: false,
  inventoryItem: "",
  editableItem: "false",
  inventory_title: "",
  title_without_edit: "",
  inventory_status: "",
  public_dealer_note: "",
  updatememo: "",
  updatepartnershipnumber: "",
  total_cost: "",
  raw_total_cost: "",
  tag_price: "",
  raw_tag_price: "",
  ismodified: false,
  modification_deatils: "",
  purchase_expense: "",
  raw_PurchasedExpense: "",
  purchase_expense_note: "",
  inventoryitemfocused: "",
  locationAutoCompleteData: { data: [] },
  locationSearch: "",
  locationloading: false,
  warentypaperset: "",
  brandloading: false,
  brand_name: "",
  archivePaperSet: "",
  warrentyExpiryDate: false,
  accessData: getComponentActionList("add_inventory"),
  viewData: getComponentViewsList("add_inventory"),
  inventryPricelist: [],
  minmax_pricelist: {
    min_inventory_cost: "",
    max_inventory_cost: "",
    min_invoice_cost: "",
    max_invoice_cost: "",
  },
  ebayAmout: "",
  croono21Ammount: "",
  retailAmount: "",
  is_inventory_title_changed: false,
  paidStatus: true,
  dealerInv: true,
  shopifyConfig: true,
  qboConfig: true,
  ebayConfig: true,
  notforSale: false,
  onPaymentDetailsErrorText: "",
  PaymentDetailsText: "",
  paymentDate: null,
  purchaseDueDate: null,
  isService: false,
  serviceDate: "",
  error: {},
  isSubmitting: false,
  fieldLoader: false,
  showAdditionalDetails: false,
  imageFiles: [],
  videoFiles: [],
  invoiceFiles: [],
  miscWatch: false,
  miscWatchModelName: "",
  miscWatchInventoryTitle: "",
  miscProductModelName: "",
  miscProductInventoryTitle: "",
  SerialNumberMisc: "Not Available-" + new Date().getTime(),
  miscWatchData: {
    modelName: "",
    brand: "",
    modelNumber: "",
    caseMaterial: "",
    caseSize: "",
    dialColor: "",
    bandMaterial: "",
  },
  miscProductData: {
    brand: "",
    modelNumber: "",
    caseMaterial: "",
    quantity: 1,
    description: "",
  },
});

function DealerProductInventoryIntakeComponent(props) {
  const [state, setStateRaw] = useState(INITIAL_STATE);
  const miscProductTitleManuallyEdited = useRef(false);
  const miscWatchTitleManuallyEdited = useRef(false);
  const setState = useCallback((updater) => {
    setStateRaw((prev) => {
      const partial = typeof updater === "function" ? updater(prev) : updater;
      return { ...prev, ...partial };
    });
  }, []);

  const stateRef = useRef(state);
  useEffect(() => {
    stateRef.current = state;
  }, [state]);
  const propsRef = useRef(props);
  useEffect(() => {
    propsRef.current = props;
  });

  const closeLimitReachedModal = () => setState({ limitReachedModalOpen: false });

  const backNavigation = () => {
    props.history.goBack();
  };

  const getAccountIds = () => {
    getBusinessAccountIds(stateRef.current.accountId, (error, res) => {
      if (error) return;
      if (res?.data && res.success == 1) {
        setState({ accountIds: res.data });
      }
    });
  };

  const getpriceListing = (id) => {
    searchinventry.getinventrypriceList(id).then((res) => {
      const list = res.data.data;
      setState({ inventryPricelist: list, loaded: true });
      for (let i = 0; i < list.length; i++) {
        if (list[i].watch_source == "Chrono24") {
          setState({ croono21Ammount: list[i].avg });
        } else if (list[i].watch_source == "Retail") {
          setState({ retailAmount: list[i].avg });
        } else if (list[i].watch_source == "EBay") {
          setState({ ebayAmout: list[i].avg });
        }
      }
    });
  };
  useEffect(() => {
    const individualBrowseWatchesStatus = props.individualBrowseWatchesInfo;
    if (!individualBrowseWatchesStatus) return;
    if (individualBrowseWatchesStatus.success === 0) {
      setState({
        onModelNumberErrorText: individualBrowseWatchesStatus.message,
        isValid: false,
      });
    } else {
      const individualBrowseWatchesData = individualBrowseWatchesStatus.data;
      if (individualBrowseWatchesData && individualBrowseWatchesData.productid) {
        setState({
          IndividualBrowseWatchesData: individualBrowseWatchesData,
          minmax_pricelist: individualBrowseWatchesData.minmax_pricelist || null,
          onModelNumberErrorText: "",
          isValid: true,
        });
      }
    }
  }, [props.individualBrowseWatchesInfo]);
  useEffect(() => {
    const timer = setTimeout(() => setState({ loaded: true }), 900);
    let PId = null;
    try {
      PId = props.match.params.productId;
      if (PId !== undefined) {
        setState((prev) => {
          const info = props.individualBrowseWatchesInfo?.data;
          const modelOrRef =
            info && info.prodattr
              ? info.prodattr.model
                ? info.prodattr.model
                : info.prodattr.reference
              : undefined;
          return {
            searchString: prev.searchString ? prev.searchString : modelOrRef,
            inventory_title: prev.searchString
              ? prev.searchString
              : info && info.prodattr
                ? info.prodattr.model
                : undefined,
            title_without_edit: prev.searchString
              ? prev.searchString
              : info && info.prodattr
                ? info.prodattr.model
                : undefined,
            ModelNumber: prev.searchString ? prev.searchString : info?.productname,
            disbleseach: true,
          };
        });
        props.individualBrowseWatch(PId);
        getpriceListing(PId);
      }
    } catch (error) {
      // console.log(error);
    }
    getAccountIds();
    return () => clearTimeout(timer);
  }, []);

  // If navigated from Product page with product state, prefill standard watch fields
  useEffect(() => {
    try {
      const navState = props.location && props.location.state;
      const product = navState && navState.product;
      if (!product) return;

      const prod = product.data || product;
      const prodAttr = prod.prodattr || {};

      setState((prev) => ({
        // ensure standard watch section
        miscWatch: false,
        // basic mapping with safe fallbacks
        inventory_title:
          prev.inventory_title && prev.inventory_title !== ""
            ? prev.inventory_title
            : prod.modelname || prodAttr.model || prod.productname || "",
        title_without_edit:
          prod.modelname || prodAttr.model || prod.productname || "",
        ModelNumber: prod.productid || prod.productid || prev.ModelNumber,
        product_name: prod.prodattr?.model || prod.modelname || prod.productname || "",
        inventoryItem: prod.modelname || prodAttr.model || prod.productname || "",
        searchString: prod.modelname || prodAttr.model || prod.productname || "",
        searchStringdetails: prod.modelname || prodAttr.model || prod.productname || "",
        // attributes
        caseMaterial: prodAttr.case_material || prod.caseMaterial || "",
        caseSize: prodAttr.case_size || prod.caseSize || "",
        dialColor: prodAttr.dial_color || prod.dialColor || "",
        bandMaterial: prodAttr.band_material || prod.bandMaterial || "",
        brand_id: prod.brandid || prod.brandid || prev.brand_id,
        brand_description: prod.brandname || prod.brand || "",
        // pricing
        minmax_pricelist: navState.inventryPricelist || prod.minmax_pricelist || prev.minmax_pricelist,
        retailAmount: navState.retailAmount || prod.price || prev.retailAmount,
      }));

      // fetch price listing if product id present
      const pid = prod.productid || prod.productid || prod.productId || prod.productId;
      if (pid) {
        getpriceListing(pid);
      }
    } catch (e) {
      // ignore
    }
  }, [props.location]);

  useEffect(() => {
    if (!props.autocompleteProducts) return;
    setState((prev) => ({
      autocomplete: { ...prev.autocomplete, data: props.autocompleteProducts.list },
    }));
  }, [props.autocompleteProducts]);

  useEffect(() => {
    const individualBrowseWatchesStatus = props.individualBrowseWatchesInfo;
    if (!individualBrowseWatchesStatus) return;
    if (individualBrowseWatchesStatus.success === 0) {
      setState({
        onModelNumberErrorText: individualBrowseWatchesStatus.message,
        isValid: false,
      });
    } else {
      const individualBrowseWatchesData = individualBrowseWatchesStatus.data;
      if (individualBrowseWatchesData && individualBrowseWatchesData.productid) {
        setState({
          IndividualBrowseWatchesData: individualBrowseWatchesData,
          minmax_pricelist: individualBrowseWatchesData.minmax_pricelist || null,
          onModelNumberErrorText: "",
          isValid: true,
        });
      }
    }
  }, [props.individualBrowseWatchesInfo]);

  const autocomplete = (evt) => {
    let text = evt.target.value;
    setState({ searchString: text, ModelNumber: text, inventory_title: text, onModelNumberErrorText: "" });
    setState({ loading: true });
    getAutocomplete(text);
  };

    const onchangeProductTitle = (event, titleKey) => {
    const value = event.target.value;

    if (value !== "") {
      setState({
        onProductTitleErrorText: "",
        [titleKey]: value,
        isValid: true,
      });
    } else {
      setState({
        onProductTitleErrorText: "",
        [titleKey]: "",
        isProduct_title_Changed: true,
        isValid: true,
      });

      setTimeout(() => {
        setState({
          isProduct_title_Changed: false,
        });
      }, 3000);
    }
  };

  const getAutocompleteRef = useRef(
    _.debounce((text) => {
      const evt = text && text.replace(/[&\/\\#,+!@^&()$~%.'":;*?<>{}]/g, "");
      propsRef.current.searchProducts({ searchText: evt }, () => {
        setState((prev) => ({ searchItems: prev.autocomplete.data }));
        setState({ loading: false });
        setState((prev) => ({
          individualsearchdata: (prev.autocomplete?.data?.length || 0) > 0,
        }));
      });
    }, 500),
  );
  const getAutocomplete = (text) => getAutocompleteRef.current(text);

  const hanldeKeyup = () => { };
  const hanldeKeydown = () => { };

  const locationAutoComplete = (evt) => {
    let text = evt.target.value;
    setState({ locationSearch: text, locationloading: true });
    getLocationAutocomplete(text);
  };

  const getLocationAutocompleteRef = useRef(
    _.debounce((evt) => {
      searchLocation({ locationSearch: evt || null }, (error, res) => {
        setState({ locationloading: false, locationAutoCompleteData: { data: res?.data } });
      });
    }, 500),
  );
  const getLocationAutocomplete = (evt) => getLocationAutocompleteRef.current(evt);

  const handleLocationFocus = (event) => {
    if (!event.target.value) {
      locationAutoComplete(event);
    }
  };

  const handleLocationBlur = () => {
    setState({ locationAutoCompleteData: { data: [] } });
  };

  const handleMiscWatchModelNameChange = (event) => {
    const nextValue = event.target.value;
    const trimmedNextValue = nextValue.trim();

    setState({
      miscWatchModelName: nextValue,
      miscWatchData: {
        ...state.miscWatchData,
        modelName: nextValue,
      },
    });

    if (!trimmedNextValue) {
      miscWatchTitleManuallyEdited.current = false;
      setState({ miscWatchInventoryTitle: "" });
      return;
    }

    if (miscWatchTitleManuallyEdited.current) {
      return;
    }

    setState({ miscWatchInventoryTitle: nextValue });
  };

  const handleMiscWatchInventoryTitleChange = (event) => {
    const nextValue = event.target.value;
    miscWatchTitleManuallyEdited.current = true;
    setState({ miscWatchInventoryTitle: nextValue });
  };

  const createMiscWatch = () => {
    miscProductTitleManuallyEdited.current = false;
    miscWatchTitleManuallyEdited.current = false;
    setState({
      miscWatch: true,
      InventoryType: "misc-watch",
      miscWatchModelName: "",
      miscWatchInventoryTitle: "",
      miscProductModelName: "",
      miscProductInventoryTitle: "",
      searchString: "",
      ModelNumber: "",
      inventory_title: "",
      title_without_edit: "",
      inventoryItem: "",
      IndividualBrowseWatchesData: [],
      selectedProduct: {},
      autocomplete: { data: [] },
      searchItems: [],
      individualsearchdata: false,
      loading: false,
      disbleseach: false,
      editableItem: false,
      miscWatchData: {
        modelName: "",
        brand: "",
        modelNumber: "",
        caseMaterial: "",
        caseSize: "",
        dialColor: "",
        bandMaterial: "",
      },
      miscProductData: {
        brand: "",
        modelNumber: "",
        caseMaterial: "",
        quantity: 1,
        description: "",
      },
      onModelNumberErrorText: "",
      isValid: true,
    });
  };
  const createMiscProduct = () => {
    miscProductTitleManuallyEdited.current = false;
    setState({
      InventoryType: MISC_PRODUCT_TYPES[0],
      miscWatchModelName: "",
      miscWatchInventoryTitle: "",
      miscProductModelName: "",
      miscProductInventoryTitle: "",
      miscProduct: true,
      searchString: "",
      ModelNumber: "",
      inventory_title: "",
      title_without_edit: "",
      inventoryItem: "",
      IndividualBrowseWatchesData: [],
      selectedProduct: {},
      autocomplete: { data: [] },
      searchItems: [],
      individualsearchdata: false,
      loading: false,
      disbleseach: false,
      editableItem: false,
      miscProductData: {
        brand: "",
        modelNumber: "",
        caseMaterial: "",
        quantity: 1,
        description: "",
      },
      onModelNumberErrorText: "",
      isValid: true,
    });
  };

  const MISC_PRODUCT_TYPES = [
    "watch related accessories",
    "apparel",
    "watch parts",
    "jewelry",
    "stones",
    "hand bags",
    "wallets",
    "bag related accessories",
    "service watches",
    "others",
  ];

  const handleListKeydown = () => { };
  const paidPaymentDateRef = useRef(null);
  const unpaidDueDateRef = useRef(null);

  const handlePaidStatusCheck = (event) => setState({ paidStatus: event.target.checked });
  const handleNotforSaleCheck = (event) => setState({ notforSale: event.target.checked });
  const handleInclude = (event) => setState({ dealerInv: event.target.checked });
  const handleIncludeShopify = (event) => setState({ shopifyConfig: event.target.checked });
  const handleIncludeQbo = (event) => setState({ qboConfig: event.target.checked });
  const handleIncludeEbay = (event) => setState({ ebayConfig: event.target.checked });

  const handlePayDateChange = (date, e) => {
    if (date === null || isValidDate(date)) {
      paidPaymentDateRef.current = date;

      setState((prev) => ({
        error: { ...prev.error, PPD: "" },
        paymentDate: e,
        onpaymentDateErrorText: "",
      }));
    } else {
      setState((prev) => ({
        error: { ...prev.error, PPD: "Invalid Date" },
      }));
    }
  };

  const onchangeProductName = (event) => {
    if (event.target.value !== "") {
      let ProductNameVal = event.target.value;
      if (!ProductNameVal) {
        setState({
          onProductNameErrorText: "Enter the correct Model Name",
          isValid: false,
        });
      } else {
        setState({
          onProductNameErrorText: "",
          product_name: event.target.value,
          isValid: true,
        });
      }
    } else {
      setState({
        onProductNameErrorText: "",
        product_name: "",
        isValid: true,
      });
    }
  }

  const handleDueDateChange = (date, e) => {
    if (date === null || isValidDate(date)) {
      setState((prev) => ({ error: { ...prev.error, PPDD: "" }, purchaseDueDate: e }));
    } else {
      setState((prev) => ({ error: { ...prev.error, PPDD: "Invalid Date" } }));
    }
  };

  const toggleAdditionalDetails = () =>
    setState((prev) => ({ showAdditionalDetails: !prev.showAdditionalDetails }));

  const onchangePaymentDetails = (event) => {
    setState({ onPaymentDetailsErrorText: "", PaymentDetailsText: event.target.value });
  };

  const onchangeModelNumber = (product) => {
    setState({
      IndividualBrowseWatchesData: product,
      disbleseach: true,
      searchString: product.modelname ? product?.modelname : product?.model ? product?.model : product?.reference,
      ModelNumber: product.productid,
      nonsearchstring: false,
      editableItem: true,
      inventoryItem: product.modelname,
      inventory_title: product.modelname,
      title_without_edit: product.modelname,
      searchStringdetails: product.modelname,
      autocomplete: { data: [] },
    });
    setState({ individualsearchdata: product.productid == null, disbleseach: true });
    props.individualBrowseWatch(product.productid);
    getpriceListing(product.productid);
    setState({
      onModelNumberErrorText: "",
      isValid: true,
      nonsearchstring: false,
      individualsearchdata: false,
    });
  };

  const onchangeLocation = (product) => {
    setState({
      locationAutoCompleteData: { data: [] },
      locationSearch: product.locations,
      isValid: true,
    });
  };

  const getContactDetailsImpl = (type, contactType, callback) => {
    let payload = {
      key: stateRef.current[type],
      type: contactType,
      accountids: stateRef.current.accountIds,
    };
    searchinventry.getInventoryContactDetails(payload, (error, response) => {
      if (response?.data && response?.status == 1) {
        callback(response.data, null);
      }
      if (error) {
        callback(null, error);
      }
    });
  };
  const debouncedGetContactDetailsRef = useRef(_.debounce(getContactDetailsImpl, 1000));
  const debouncedGetContactDetails = (...args) => debouncedGetContactDetailsRef.current(...args);

  const destructureData = (data) => {
    const groupedByEmail = {};
    data.forEach((value) => {
      const Email = value.email;
      groupedByEmail[Email] = groupedByEmail[Email] || [];
      groupedByEmail[Email].push(value);
    });
    return Object.values(groupedByEmail);
  };

  const onchangeContactSuggestion = (event, type, contactType) => {
    let value = event.target.value;
    let newState = { isValid: true, fieldLoader: true };
    if (type === "PurchasedFrom") newState.PurchasedFrom = value;
    else if (type === "MemoDetails") newState.MemoDetails = value;
    else if (type === "PartnershipDetails") newState.PartnershipDetails = value;
    setState(newState);
    if (value && value?.length > 2) {
      debouncedGetContactDetails(type, contactType, (data = [], error) => {
        if (data?.length > 0) {
          const filteredData = destructureData(data);
          setState((prevState) => ({
            dataset: filteredData,
            purchasedFromArray: type === "PurchasedFrom" ? data : prevState.purchasedFromArray,
            memoDetailsArray: type === "MemoDetails" ? data : prevState.memoDetailsArray,
            partnershipDetailsArray:
              type === "PartnershipDetails" ? data : prevState.partnershipDetailsArray,
            isPopOverPurchasedFrom: type == "PurchasedFrom",
            isPopOverMemoDetails: type == "MemoDetails",
            isPopOverPartnershipDetails: type == "PartnershipDetails",
            fieldLoader: false,
          }));
        } else {
          setState((prevState) => ({
            purchasedFromArray: type === "PurchasedFrom" ? [] : prevState.purchasedFromArray,
            memoDetailsArray: type === "MemoDetails" ? [] : prevState.memoDetailsArray,
            partnershipDetailsArray:
              type === "PartnershipDetails" ? [] : prevState.partnershipDetailsArray,
            dataset: [],
            fieldLoader: false,
          }));
        }
      });
    } else {
      setState((prevState) => ({
        purchasedFromArray: type === "PurchasedFrom" ? [] : prevState.purchasedFromArray,
        memoDetailsArray: type === "MemoDetails" ? [] : prevState.memoDetailsArray,
        partnershipDetailsArray:
          type === "PartnershipDetails" ? [] : prevState.partnershipDetailsArray,
        dataset: [],
        fieldLoader: false,
      }));
    }
  };

  const handleContactSelection = (data, type) => {
    const fieldName = type;
    const value = [
      data?.businessname,
      data?.firstname && data?.lastname
        ? `${data?.firstname} ${data?.lastname}`
        : data?.firstname || data?.lastname,
    ]
      ?.filter(Boolean)
      ?.join(", ");
    const contactId = data?.contactid;
    setState((prevState) => ({
      [fieldName]: value,
      isPopOverPurchasedFrom: fieldName === "PurchasedFrom" ? false : prevState.isPopOverPurchasedFrom,
      isPopOverMemoDetails: fieldName === "MemoDetails" ? false : prevState.isPopOverMemoDetails,
      isPopOverPartnershipDetails:
        fieldName === "PartnershipDetails" ? false : prevState.isPopOverPartnershipDetails,
      purchaseFromContactId:
        fieldName === "PurchasedFrom" ? contactId : prevState.purchaseFromContactId,
      memoContactId: fieldName === "MemoDetails" ? contactId : prevState.memoContactId,
      partnerContactId:
        fieldName === "PartnershipDetails" ? contactId : prevState.partnerContactId,
    }));
  };

  const handleContact = (val) =>
    [
      [val?.firstname, val?.lastname].filter(Boolean).join(" "),
      val?.businessname,
      val?.billingaddress1,
      val?.billingaddress2,
      val?.billingcity,
      val?.billingstate,
      val?.billingcountry,
      val?.billingzipcode,
    ]
      .filter(Boolean)
      .join(", ");

  const clearContactSuggestion = (type) => {
    setState((prev) => ({
      [type]: "",
      [`${type.charAt(0).toLowerCase() + type.slice(1)}Array`]: [],
      dataset: [],
      purchaseFromContactId: type === "PurchasedFrom" ? null : prev.purchaseFromContactId,
      memoContactId: type === "MemoDetails" ? null : prev.memoContactId,
      partnerContactId: type === "PartnershipDetails" ? null : prev.partnerContactId,
    }));
  };

  const handleVisibleChange = (visible) => {
    setState({
      isPopOverPurchasedFrom: visible,
      isPopOverMemoDetails: visible,
      isPopOverPartnershipDetails: visible,
    });
  };

  const onchangePurchasedPrice = (event) => {
    let value = event.target.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    const formattedPrice = formatNumber(value);
    setState((prev) => {
      const total = calculateTotalCost(value, prev.raw_PurchasedExpense);
      return {
        raw_PurchasedPrice: value,
        PurchasedPrice: formattedPrice,
        isDirty: true,
        raw_total_cost: total.raw,
        total_cost: total.formatted,
      };
    });
  };

  const onchangeSerialNumber = (event) => {
    if (event.target.value !== "") {
      let SerialNumberVal = event.target.value;
      if (!SerialNumberVal) {
        setState({
          onSerialNumberErrorText: "Enter the Serial Number",
          isValid: false,
        });
      } else {
        setState({
          onSerialNumberErrorText: "",
          SerialNumber: event.target.value,
          isValid: true,
        });
      }
    } else {
      setState({
        onSerialNumberErrorText: "",
        SerialNumber: event.target.value,
        isValid: true,
      });
    }
  };

  const onchangeSerialNumberMisc = (event) => {
    const value = event.target.value;
    if (!value) {
      setState({
        onSerialNumberMiscErrorText: "Enter the Serial Number",
        SerialNumberMisc: "",
        isValid: false,
      });
    } else {
      setState({
        onSerialNumberMiscErrorText: "",
        SerialNumberMisc: value,
        isValid: true,
      });
    }
  };

  const onchangeTagPrice = (event) => {
    let value = event.target.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    if (value === "") {
      setState({
        tag_price: "",
        raw_tag_price: "",
        isValid: true,
        isEdited: true,
        isDirty: true,
      });
      return;
    }
    let formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    setState({
      onSerialNumberErrorText: "",
      onTagPriceErrorText: "",
      tag_price: formatted,
      raw_tag_price: value,
      isEdited: true,
      isValid: true,
      isDirty: true,
    });
  };

  const onchangePurchaseExpense = (event) => {
    let value = event.target.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    const formattedExpense = formatNumber(value);
    setState((prev) => {
      const total = calculateTotalCost(prev.raw_PurchasedPrice, value);
      return {
        raw_PurchasedExpense: value,
        purchase_expense: formattedExpense,
        isDirty: true,
        raw_total_cost: total.raw,
        total_cost: total.formatted,
      };
    });
  };

  const onchangePurchaseExpenseNote = (event) => {
    if (event.target.value !== "") {
      let val = event.target.value;
      if (!val) {
        setState({
          onPurchaseExpenseNoteErrorText: "Enter the correct Purchase Expense Notes",
          isValid: false,
        });
      } else {
        setState({ onPurchaseExpenseNoteErrorText: "", purchase_expense_note: event.target.value, isValid: true });
      }
    }
  };

  const onchangePublicDealerNote = (event) => {
    setState({ onPublicDealerNoteErrorText: "", public_dealer_note: event.target.value, isValid: true });
  };

  const onchangeModificationDetails = (event) => {
    let val = event.target.value;
    setState({ modification_deatils: event.target.value, isValid: !!val });
  };

  const onchangeInventoryStatus = (event) => {
    if (event.target.value !== "") {
      let val = event.target.value;
      if (!val) {
        setState({ onInventoryStatusErrorText: "Enter the correct inventory status", isValid: false });
      } else {
        setState({ onInventoryStatusErrorText: "", inventory_status: event.target.value, isValid: true });
      }
    }
  };

  const onchangeInventoryType = (event) => {
    setState({ inventory_type: event.target.value, isValid: true });
  };

  const onchangeCondition = (event, value) => {
    if (!value) {
      setState({ onConditionErrorText: "Choose the correct Condition", isValid: false });
    } else if (value === 5) {
      setState({
        onCoditionTenSuccessText: "Pre Owned",
        onConditionErrorText: "",
        Condition: value,
        isValid: true,
      });
    } else {
      setState({ onConditionErrorText: "", onCoditionTenSuccessText: "", Condition: value, isValid: true });
    }
  };

  const handleCheck1 = (event) => {
    if (event.target.checked == true) {
      setState({ box: true });
      localStorage.setItem("warranty_box", "1");
    } else {
      setState({ box: false });
      localStorage.setItem("warranty_box", "0");
    }
  };

  const loadMiscWatchData = () => {
    props.brandList();
    props.caseMaterial();
    props.brandMaterial();
  };

  const loadMiscProductData = () => {
    props.brandList();
  }

  const handleCheck2 = (event) => {
    setState({ ismodified: !!event.target.checked });
  };

  const onchangeDealerNotes = (event) => {
    if (event.target.value !== "") {
      let val = event.target.value;
      if (!val) {
        setState({ onDealerNotesErrorText: "Enter the Dealer Notes", isValid: false });
      } else {
        setState({ onDealerNotesErrorText: "", DealerNotes: event.target.value, isValid: true });
      }
    }
  };

  const onchangeInventoryTitle = (event) => {
    setState({ inventory_title: event.target.value });
    if (event.target.value === "") {
      setState({ is_inventory_title_changed: true });
      setTimeout(() => setState({ is_inventory_title_changed: false }), 3000);
    }
  };

  const onchangeNumberOfLinks = (event) => {
    let value = event.target.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    if (value === "") {
      setState({ NumberOfLinks: "", raw_NumberOfLinks: "", isValid: false });
      return;
    }
    let formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    setState({ onNumberOfLinksErrorText: "", NumberOfLinks: formatted, raw_NumberOfLinks: value, isValid: true });
  };

  const onchangeBandSize = (event) => {
    const value = event.target.value;

    if (value !== "" && !/^\d+$/.test(value)) {
      return;
    }

    setState({
      BandSize: value,
      onBandSizeErrorText: "",
      isValid: true,
    });
  };

  const onchangeWholeSalePrice = (event) => {
    let value = event.target.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    if (value === "") {
      setState({ WholeSalePrice: "", raw_Wholesale_Price: "", isValid: false });
      return;
    }
    let formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    setState({ onWholeSalePriceErrorText: "", WholeSalePrice: formatted, raw_Wholesale_Price: value, isValid: true });
  };

  const editinvnetrydeatils = () => {
    setState({
      disbleseach: false,
      searchString: "",
      IndividualBrowseWatchesData: [],
      inventory_title: "",
      title_without_edit: "",
      autocomplete: { data: [] },
    });
  };

  const onchangeRetailPrice = (event) => {
    let value = event.target.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    if (value === "") {
      setState({ RetailPrice: "", raw_Retail_Wireprice: "", isValid: false });
      return;
    }
    let formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    setState({ onRetailPriceErrorText: "", RetailPrice: formatted, raw_Retail_Price: value, isValid: true });
  };

  const onchangeRetailWirePrice = (event) => {
    let value = event.target.value.replace(/,/g, "");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    if (value === "") {
      setState({ RetailWirePrice: "", raw_Retail_Wireprice: "", isValid: false });
      return;
    }
    let formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    setState({
      onRetailWirePriceErrorText: "",
      RetailWirePrice: formatted,
      raw_Retail_Wireprice: value,
      isValid: true,
    });
  };

  const handleImagesSelected = (fileList) => {
    const incomingFiles = Array.from(fileList);
    setState((prev) => {
      const used = new Set(prev.imageFiles.map((f) => f.position));
      const newFiles = incomingFiles.map((file) => {
        const entry = makeFileEntry(file);
        let i = 0;
        let position = getPositionForIndex(i);
        while (used.has(position)) {
          i += 1;
          position = getPositionForIndex(i);
        }
        used.add(position);
        return { ...entry, position };
      });
      return { imageFiles: [...prev.imageFiles, ...newFiles] };
    });
  };

  const removeImageFile = (id) => {
    setState((prev) => ({
      imageFiles: prev.imageFiles.filter((f) => {
        if (f.id === id) URL.revokeObjectURL(f.url);
        return f.id !== id;
      }),
    }));
  };

  const handleVideosSelected = (fileList) => {
    const newFiles = Array.from(fileList).map((file) => ({ ...makeFileEntry(file), duration: null }));
    setState((prev) => ({ videoFiles: [...prev.videoFiles, ...newFiles] }));
    newFiles.forEach((nf) => {
      getVideoDuration(nf.file).then((seconds) => {
        setState((prev) => ({
          videoFiles: prev.videoFiles.map((v) => (v.id === nf.id ? { ...v, duration: seconds } : v)),
        }));
      });
    });
  };

  const removeVideoFile = (id) => {
    setState((prev) => ({
      videoFiles: prev.videoFiles.filter((f) => {
        if (f.id === id) URL.revokeObjectURL(f.url);
        return f.id !== id;
      }),
    }));
  };

  const handleInvoiceFilesSelected = (fileList) => {
    const newFile = makeFileEntry(fileList[0]);
    setState((prev) => {
      prev.invoiceFiles.forEach((f) => URL.revokeObjectURL(f.url));
      return { invoiceFiles: [newFile] };
    });
  };

  const removeInvoiceFile = () => {
    setState((prev) => {
      prev.invoiceFiles.forEach((f) => URL.revokeObjectURL(f.url));
      return { invoiceFiles: [] };
    });
  };

  const handleTypeOfPaperCheck = (event) => {
    const { value, checked } = event.target;
    if (value === "Warranty" && checked) {
      setState({
        warrentyExpiryDate: true,
        WarentyPaper: true,
        warentypaperset: "1",
        error: { ...state.error, Warranty: "" },
      });
    } else if (value === "Warranty" && !checked) {
      setState({
        warrentyExpiryDate: false,
        WarentyPaper: false,
        warentypaperset: "",
        PurchasedDate1: "",
        error: { ...state.error, Warranty: "" },
      });
    } else if (value === "Archive" && checked) {
      setState({
        archivePaperSet: "1",
        archivePaper: true,
        error: { ...state.error, Archive: "" },
      });
    } else if (value === "Archive" && !checked) {
      setState({
        archivePaperSet: "",
        archivePaper: false,
        archiveDate: "",
        error: { ...state.error, Archive: "" },
      });
    } else if (value === "isService" && checked) {
      setState({ isService: true, error: { ...state.error, Service: "" } });
    } else if (value === "isService" && !checked) {
      setState({ isService: false, serviceDate: "", error: { ...state.error, Service: "" } });
    }
  };

  const validateInput = () => {
    let onModelNumberErrorText = "";
    let onSerialNumberErrorText = "";
    let onSerialNumberMiscErrorText = "";
    let onConditionErrorText = "";
    let modificationDetailsError = "";
    let onpaymentDateErrorText = "";
    let isValid = true;
    const s = stateRef.current;
    if (s.ModelNumber?.length === 0) {
      onModelNumberErrorText = "Please select a Watch";
      isValid = false;
    }
    if (s.ismodified && s.modification_deatils && s.modification_deatils?.length === 0) {
      modificationDetailsError = "Enter Modification Details";
      isValid = false;
    }
    if (s.InventoryType !== "misc-watch" && !s.SerialNumber) {
      onSerialNumberErrorText = "Enter Serial Number";
      isValid = false;
    }
    if (s.InventoryType === "misc-watch" && !s.SerialNumberMisc) {
      onSerialNumberMiscErrorText = "Enter Serial Number";
      isValid = false;
    }
    if (!s.Condition) {
      onConditionErrorText = "Enter Condition";
      isValid = false;
    }
    setState({
      onModelNumberErrorText,
      onpaymentDateErrorText,
      onSerialNumberErrorText,
      onSerialNumberMiscErrorText,
      onConditionErrorText,
      modificationDetailsError,
    });

    if (!isValid) {
      const firstErrorFieldId = onModelNumberErrorText
        ? "autocomplete"
        : onSerialNumberErrorText
          ? "serialNumber"
          : onSerialNumberMiscErrorText
            ? "serialNumberMisc"
            : onConditionErrorText
              ? "conditionField"
              : modificationDetailsError
                ? "modificationDetails"
                : null;
      const errorEl = firstErrorFieldId && document.getElementById(firstErrorFieldId);
      if (errorEl) {
        errorEl.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }

    return isValid;
  };

  const handleDateChange = (date, e) => {
    if (date === null || isValidDate(date)) {
      setState((prev) => ({ error: { ...prev.error, PD: "" }, PurchasedDate: e }));
    } else {
      setState((prev) => ({ error: { ...prev.error, PD: "Invalid Date" } }));
    }
  };

  const handleWatchTypeChange = (event) => {
    const value = event.target.value;
    miscProductTitleManuallyEdited.current = false;
    miscWatchTitleManuallyEdited.current = false;
    setState({
      onSerialNumberErrorText: "",
      onSerialNumberMiscErrorText: "",
      SerialNumber: "",
      miscWatchModelName: "",
      miscWatchInventoryTitle: "",
      miscProductModelName: "",
      miscProductInventoryTitle: "",
    });

    if (value === "misc-watch") {
      setState({
        InventoryType: "misc-watch",
        product_title: undefined,
        searchString: "",
        ModelNumber: "",
        inventory_title: "",
        title_without_edit: "",
        inventoryItem: "",
        IndividualBrowseWatchesData: [],
        selectedProduct: {},

        autocomplete: {
          data: [],
        },

        searchItems: [],
        individualsearchdata: false,
        loading: false,
        miscWatchData: {
          modelName: "",
          brand: "",
          modelNumber: "",
          caseMaterial: "",
          caseSize: "",
          dialColor: "",
          bandMaterial: "",
        },
        miscProductData: {
          brand: "",
          modelNumber: "",
          caseMaterial: "",
          quantity: 1,
          description: "",
        },

        disbleseach: false,
        editableItem: false,
        onModelNumberErrorText: "",
      });

      return;
    }

    if (value === "") {
      setState({
        InventoryType: "",
        miscWatchData: {
          modelName: "",
          brand: "",
          modelNumber: "",
          caseMaterial: "",
          caseSize: "",
          dialColor: "",
          bandMaterial: "",
        },
        miscProductData: {
          brand: "",
          modelNumber: "",
          caseMaterial: "",
          quantity: 1,
          description: "",
        },
        searchString: "",
        ModelNumber: "",
        inventory_title: "",
        title_without_edit: "",
        inventoryItem: "",
        IndividualBrowseWatchesData: [],
        selectedProduct: {},
        autocomplete: { data: [] },
        searchItems: [],
        individualsearchdata: false,
        loading: false,
        disbleseach: false,
        editableItem: false,
        onModelNumberErrorText: "",
      });
      return;
    }

    setState({
      InventoryType: value,
      miscWatchModelName: "",
      miscWatchInventoryTitle: "",
      miscProductModelName: "",
      miscProductInventoryTitle: "",
      miscWatchData: {
        modelName: "",
        brand: "",
        modelNumber: "",
        caseMaterial: "",
        caseSize: "",
        dialColor: "",
        bandMaterial: "",
      },
      miscProductData: {
        brand: "",
        modelNumber: "",
        caseMaterial: "",
        quantity: 1,
        description: "",
      },
      searchString: "",
      ModelNumber: "",
      inventory_title: "",
      IndividualBrowseWatchesData: [],
      selectedProduct: {},
      autocomplete: {
        data: [],
      },
    });

    if (value === "misc-watch" || MISC_PRODUCT_TYPES.includes(value)) {
      loadMiscProductData();
    }
  };

  const handleDateChange1 = (date, e, type) => {
    if (date === null || isValidDate(date)) {
      setState((prev) => ({ error: { ...prev.error, [type]: "" } }));
      if (type === "Warranty") setState({ PurchasedDate1: e });
      else if (type === "Archive") setState({ archiveDate: e });
      else if (type === "Service") setState({ serviceDate: e });
    } else {
      setState((prev) => ({ error: { ...prev.error, [type]: "Invalid Date" } }));
    }
  };

  const onchangeBrandName = (event) => {
    setState((prev) => ({
      ...prev,
      brandloading: true,
    }));

    if (event.target.value.length > 0) {
      const searchString = event.target.value.toLowerCase();
      const filterArray = (props.brandInfo?.data || []).filter((data) => {
        const brandName = data.brandname.toLowerCase();
        return brandName.indexOf(searchString) !== -1;
      });

      setState((prev) => ({
        ...prev,
        onBrandNameErrorText: "",
        brand_name: event.target.value,
        isValid: true,
        brandloading: false,
        brandAutoCompleteData: { data: filterArray },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        brandloading: false,
        onBrandNameErrorText: "",
        brand_name: event.target.value,
        isValid: true,
        brandAutoCompleteData: { data: [] },
      }));
    }
  };

  const onchangebrand = (product) => {
    setState({
      brandAutoCompleteData: { data: [] },
      brand_name: product.brandname,
      isValid: true,
    });
  }

  const onchangecasematerial = (product) => {
    setState({
      caseMaterialAutoCompleteData: { data: [] },
      case_material: product.casematerial,
      isValid: true,
    });
  }

  const onchangeCaseMaterial = (event) => {
    setState({
      caseMaterialloading: true,
    });

    if (event.target.value.length > 0) {
      const searchString = event.target.value.toLowerCase();
      const filterArray = (props.caseMaterialInfo?.data || []).filter(function (data) {
        const caseMaterial = data.casematerial.toLowerCase();
        return !(caseMaterial.indexOf(searchString) === -1);
      });
      setState({
        onCaseMaterialErrorText: "",
        case_material: event.target.value,
        isValid: true,
        caseMaterialloading: false,
        caseMaterialAutoCompleteData: { data: filterArray },
      });
    } else {
      setState({
        caseMaterialloading: false,
        onCaseMaterialErrorText: "",
        case_material: event.target.value,
        isValid: true,
        caseMaterialAutoCompleteData: { data: [] },
      });
    }
  }

  const onchangebandmaterial = (product) => {
    setState({
      bandMaterialAutoCompleteData: { data: [] },
      band_material: product.bandmaterial,
      isValid: true,
    });
  }

  const onchangeBandMaterial = (event) => {
    setState({ bandMaterialloading: true });

    if (event.target.value.length > 0) {
      const searchString = event.target.value.toLowerCase();
      const filterArray = (props.brandMaterialInfo?.data || []).filter((data) =>
        data.bandmaterial.toLowerCase().includes(searchString)
      );

      setState({
        onBandMaterialErrorText: "",
        band_material: event.target.value,
        isValid: true,
        bandMaterialloading: false,
        bandMaterialAutoCompleteData: { data: filterArray },
      });
    } else {
      setState({
        bandMaterialloading: false,
        onBandMaterialErrorText: "",
        band_material: event.target.value,
        isValid: true,
        bandMaterialAutoCompleteData: { data: [] },
      });
    }
  };

  const INVENTORY_MEDIA_POSITIONS = [
    "front",
    "back",
    "left",
    "right",
    "free_form",
    "buckle_opened",
    "buckle_closed",
    "wrist_shot",
  ];

  const getPositionForIndex = (index) =>
    INVENTORY_MEDIA_POSITIONS[index] ||
    `preimage${index - INVENTORY_MEDIA_POSITIONS.length + 1}`;

  const uploadInventoryMedia = (inventoryId) => {
    const s = stateRef.current;

    s.imageFiles.forEach(({ file, position }) => {
      const fd = new FormData();
      fd.set("inventory_id", inventoryId);
      fd.set("position", position);
      fd.set("image", file);
      fd.set("modified_by", props.currentUser.userId);
      addInventoryImage(fd, (error) => {
        if (error) {
          toast(error?.response?.data?.message || error?.message || "Image upload failed", {
            autoClose: 2000,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      });
    });

    s.videoFiles.forEach(({ file }, index) => {
      const position = `video${index + 1}`;
      const fd = new FormData();
      fd.set("inventory_id", inventoryId);
      fd.set("position", position);
      fd.set("image", file);
      fd.set("modified_by", props.currentUser.userId);
      addInventoryImage(fd, (error) => {
        if (error) {
          toast(error?.response?.data?.message || error?.message || "Video upload failed", {
            autoClose: 2000,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      });
    });
  };

  const submitForm = (event) => {
    const s0 = stateRef.current;
    if (s0.InventoryType === "misc-watch") {
      submitMiscWatch();
      return;
    }
    if (MISC_PRODUCT_TYPES.includes(s0.InventoryType)) {
      submitMiscProduct();
      return;
    }
    let x = localStorage.getItem("warranty_box");
    if (validateInput()) {
      setState({ isSubmitting: true });
      const s = stateRef.current;
      var attributes = {
        reference: s.IndividualBrowseWatchesData.model ? s.IndividualBrowseWatchesData.model : "",
        productname: s.IndividualBrowseWatchesData.productname ? s.IndividualBrowseWatchesData.productname : "",
        modelname: s.IndividualBrowseWatchesData.modelname ? s.IndividualBrowseWatchesData.modelname : "",
        productfamily: s.IndividualBrowseWatchesData.productfamily ? s.IndividualBrowseWatchesData.productfamily : "",
        bezel: "",
        gender: "",
        glass: s.IndividualBrowseWatchesData?.prodattr?.glass ? s.IndividualBrowseWatchesData.prodattr.glass : "",
        shape: s.IndividualBrowseWatchesData?.prodattr?.shape ? s.IndividualBrowseWatchesData.prodattr.shape : "",
        waterresistant: s.IndividualBrowseWatchesData.waterresistant ? s.IndividualBrowseWatchesData.waterresistant : "",
        caliber: s.IndividualBrowseWatchesData?.prodattr?.caliber ? s.IndividualBrowseWatchesData.waterresistant : "",
        movement: s.IndividualBrowseWatchesData?.prodattr?.movement ? s.IndividualBrowseWatchesData?.prodattr?.movement : "",
        casesize: s.IndividualBrowseWatchesData?.prodattr?.casesize ? s.IndividualBrowseWatchesData?.prodattr?.casesize : "",
        powerreserve: s.IndividualBrowseWatchesData?.prodattr?.powerreserve
          ? s.IndividualBrowseWatchesData?.prodattr?.powerreserve
          : "",
        indices: s.IndividualBrowseWatchesData?.prodattr?.indices ? s.IndividualBrowseWatchesData?.prodattr?.indices : "",
        casematerial: s.IndividualBrowseWatchesData?.prodattr?.casematerial
          ? s.IndividualBrowseWatchesData?.prodattr?.casematerial
          : "",
        bandmaterial: s.IndividualBrowseWatchesData?.prodattr?.bandmaterial
          ? s.IndividualBrowseWatchesData?.prodattr?.bandmaterial
          : "",
        dialcolor: s.IndividualBrowseWatchesData?.prodattr?.dialcolor ? s.IndividualBrowseWatchesData.prodattr.dialcolor : "",
        circa: "",
        productcode: "",
        luminous: "",
        bandcolor: "",
        bandtype: "",
        buckletype: "",
      };
      if (s.BandSize === 0) setState({ BandSize: "" });

      const buildData = () => ({
        product_id: s.IndividualBrowseWatchesData.productid ? s.IndividualBrowseWatchesData.productid : "",
        attributes: attributes ? attributes : "",
        accountId: s.accountId,
        purchase_price: s.raw_PurchasedPrice ? s.raw_PurchasedPrice : "",
        purchase_date: s.PurchasedDate ? s.PurchasedDate : "",
        purchase_from: s.PurchasedFrom ? s.PurchasedFrom : "",
        serial_no: s.SerialNumber ? s.SerialNumber : "",
        inventory_type: s.InventoryType || s.inventory_type || null,
        memo_details: s.MemoDetails ? s.MemoDetails : null,
        partnership_detais: s.PartnershipDetails ? s.PartnershipDetails : null,
        condition: s.Condition ? s.Condition : "1",
        band_size: s.BandSize ? s.BandSize : "",
        links: s.raw_NumberOfLinks ? s.raw_NumberOfLinks : "",
        note: s.DealerNotes ? s.DealerNotes : "",
        wholesale_price: s.raw_Wholesale_Price ? s.raw_Wholesale_Price : "",
        retail_price: s.raw_Retail_Price ? s.raw_Retail_Price : "",
        retailwire_price: s.raw_Retail_Wireprice ? s.raw_Retail_Wireprice : "",
        warranty_paper: s.warentypaperset ? s.warentypaperset : "",
        archive: s.archivePaperSet ? s.archivePaperSet : "",
        is_service: s.isService ? s.isService : "",
        service_date: s.serviceDate ? s.serviceDate : "",
        warranty_box: x ? x : "0",
        warranty_date: s.PurchasedDate1 ? s.PurchasedDate1 : "",
        archive_date: s.archiveDate ? s.archiveDate : "",
        created_by: props.currentUser.userId ? s.PurchasedDate1 : "",
        inventory_title:
          s.inventory_title && s.inventory_title !== ""
            ? s.inventory_title
            : s.IndividualBrowseWatchesData && s.IndividualBrowseWatchesData.prodattr
              ? s.IndividualBrowseWatchesData.prodattr?.model
              : "",
        inventory_status: s.inventory_status ? s.inventory_status : null,
        public_dealer_note: s.public_dealer_note ? s.public_dealer_note : "",
        memo_number: s.updatememo ? s.updatememo : "",
        partnership_number: s.updatepartnershipnumber || null,
        total_cost: s.raw_total_cost ? s.raw_total_cost : "",
        tag_price: s.raw_tag_price ? s.raw_tag_price : "",
        modification_deatils: s.modification_deatils ? s.modification_deatils : "",
        ismodified: s.ismodified || false,
        purchase_expense: s.raw_PurchasedExpense ? s.raw_PurchasedExpense : "",
        purchase_invoice_paid: s.paidStatus ? s.paidStatus : false,
        purchase_payment_date: s.paymentDate || null,
        purchase_payment_details: s.PaymentDetailsText ? s.PaymentDetailsText : "",
        purchase_payment_duedate: s.purchaseDueDate || null,
        purchase_expense_note: s.purchase_expense_note ? s.purchase_expense_note : "",
        paperType: s.typeOfPaper || null,
        is_include_dealerfeed: s.dealerInv,
        is_include_shopify: s.shopifyConfig,
        is_include_qbo: s.qboConfig,
        is_include_ebayconfig: s.ebayConfig,
        inventory_location: s.locationSearch || "",
        purchasefromcontactid: s.purchaseFromContactId || null,
        memocontactid: s.memoContactId || null,
        partnercontactid: s.partnerContactId || null,
      });

      let data = buildData();

      if (s.IndividualBrowseWatchesData?.productid?.length === 0) delete data.product_id;
      if (attributes?.length === 0) delete data.attributes;
      if (!s.PurchasedPrice) delete data.purchase_price;
      if (!s.PurchasedDate) delete data.purchase_date;
      if (!s.PurchasedFrom) delete data.purchase_from;
      if (!s.SerialNumber) delete data.serial_no;
      if (!s.Condition) delete data.condition;
      if (!s.BandSize) delete data.band_size;
      if (!s.NumberOfLinks) delete data.links;
      if (!s.DealerNotes) delete data.note;
      if (!s.WholeSalePrice) delete data.wholesale_price;
      if (!s.RetailPrice) delete data.retail_price;
      if (!s.RetailWirePrice) delete data.retailwire_price;
      if (s.warentypaperset === "" || !s.warentypaperset) delete data.warranty_paper;
      if (!s.archivePaperSet || s.archivePaperSet === "") delete data.archive;
      if (!s.isService) delete data.is_service;
      if (!s.serviceDate) delete data.service_date;
      if (x === "" || !x) delete data.warranty_box;
      if (!s.PurchasedDate1) delete data.warranty_date;
      if (!s.archiveDate) delete data.archive_date;
      if (props.currentUser.userId) delete data.created_by;
      if (!s.total_cost) delete data.total_cost;
      if (!s.tag_price) delete data.tag_price;
      if (!s.purchase_expense) delete data.purchase_expense;
      if (!s.purchase_expense_note) delete data.purchase_expense_note;
      if (!s.locationSearch) delete data.inventory_location;
      if (!s.public_dealer_note) delete data.public_dealer_note;
      if (!s.inventory_status) delete data.inventory_status;
      if (!s.MemoDetails) delete data.memo_details;
      if (!s.updatememo) delete data.memo_number;
      if (!s.updatepartnershipnumber) delete data.partnership_number;
      if (!s.PartnershipDetails) delete data.partnership_detais;
      if (!s.modification_deatils) delete data.modification_deatils;
      if (!data.purchase_payment_date || !s.paymentDate || !s.paidStatus) delete data.purchase_payment_date;
      if (!data.purchase_payment_duedate || !s.purchaseDueDate || s.paidStatus) delete data.purchase_payment_duedate;
      if (!s.purchaseFromContactId) delete data.purchasefromcontactid;
      if (!s.memoContactId) delete data.memocontactid;
      if (!s.partnerContactId) delete data.partnercontactid;

      let formData = new FormData();
      s.invoiceFiles.forEach(({ file }) => formData.append("image", file));
      for (const key in data) {
        formData.set(key, data[key]);
      }

      addInventoryData(formData, (error, res) => {
        setState({ isSubmitting: false });
        if (error) {
          toast(error?.response?.data?.message || error?.message || "Inventory creation failed", {
            autoClose: 2000,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        } else if (res?.success === 0 && res?.data?.isLimitExited) {
          setState({ limitReachedModalOpen: true });
        } else {
          if (res?.data?.inventoryid) {
            uploadInventoryMedia(res.data.inventoryid);
          }
          if (typeof props.submitted === "function") {
            props.submitted(res?.data?.inventoryid);
          }
          localStorage.removeItem("warranty_box");
          setState({ inventoryid: res?.data });
          props.history.push("/myinventory");
          setTimeout(() => window.scrollTo(0, 0), 50);
        }
      });
    }
  };
  const submitMiscWatch = () => {
    const s = stateRef.current;
    if (!s.SerialNumberMisc || !s.SerialNumberMisc.trim()) {
      setState({ onSerialNumberMiscErrorText: "Enter Serial Number" });
      const errorEl = document.getElementById("serialNumberMisc");
      if (errorEl) errorEl.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }
    const x = localStorage.getItem("warranty_box");
    setState({ isSubmitting: true });

    const miscWatchInventoryTitleValue = typeof s.miscWatchInventoryTitle === "string"
      ? s.miscWatchInventoryTitle.trim()
      : "";

    const attributes = {
      product_name: s.miscWatchModelName || "",
      ...(miscWatchInventoryTitleValue ? { product_title: miscWatchInventoryTitleValue } : {}),
      brand_name: s.brand_name || "",
      model_number: s.miscWatchData.modelNumber || "",
      case_material: s.case_material || "",
      case_size: s.miscWatchData.caseSize || "",
      dial_color: s.miscWatchData.dialColor || "",
      band_material: s.band_material || "",
    };

    const data = {
      technical_details: JSON.stringify(attributes),
      accountId: s.accountId,
      purchase_price: s.raw_PurchasedPrice || "",
      purchase_date: s.PurchasedDate || "",
      purchase_from: s.PurchasedFrom || "",
      serial_no: s.SerialNumberMisc || "",
      inventory_type: s.inventory_type || "",
      memo_details: s.MemoDetails || "",
      partnership_detais: s.PartnershipDetails || "",
      condition: s.Condition || "1",
      band_size: s.BandSize || "",
      links: s.raw_NumberOfLinks || "",
      note: s.DealerNotes || "",
      wholesale_price: s.raw_Wholesale_Price || "",
      retail_price: s.raw_Retail_Price || "",
      retailwire_price: s.raw_Retail_Wireprice || "",
      warranty_paper: s.warentypaperset || "",
      archive: s.archivePaperSet || "",
      is_service: s.isService || "",
      service_date: s.serviceDate || "",
      warranty_box: x || "0",
      warranty_date: s.PurchasedDate1 || "",
      archive_date: s.archiveDate || "",
      inventory_status: s.inventory_status || "",
      public_dealer_note: s.public_dealer_note || "",
      memo_number: s.updatememo || "",
      partnership_number: s.updatepartnershipnumber || null,
      total_cost: s.raw_total_cost || "",
      tag_price: s.raw_tag_price || "",
      modification_deatils: s.modification_deatils || "",
      ismodified: s.ismodified || false,
      purchase_expense: s.raw_PurchasedExpense || "",
      purchase_invoice_paid: s.paidStatus || false,
      purchase_payment_date: s.paymentDate || null,
      purchase_payment_details: s.PaymentDetailsText || "",
      purchase_payment_duedate: s.purchaseDueDate || null,
      purchase_expense_note: s.purchase_expense_note || "",
      paperType: s.typeOfPaper || null,
      inventory_location: s.locationSearch || "",
      type: "misc_watch",
      category: null,
      is_include_dealerfeed: s.dealerInv,
      is_include_shopify: s.shopifyConfig,
      is_include_qbo: s.qboConfig,
      is_include_ebayconfig: s.ebayConfig,
      purchasefromcontactid: s.purchaseFromContactId || null,
      memocontactid: s.memoContactId || null,
      partnercontactid: s.partnerContactId || null,
    };

    if (miscWatchInventoryTitleValue) {
      data.inventory_title = miscWatchInventoryTitleValue;
    } else {
      delete data.inventory_title;
    }

    if (!s.PurchasedPrice) delete data.purchase_price;
    if (!s.PurchasedDate) delete data.purchase_date;
    if (!s.PurchasedFrom) delete data.purchase_from;
    if (!s.BandSize) delete data.band_size;
    if (!s.NumberOfLinks) delete data.links;
    if (!s.DealerNotes) delete data.note;
    if (!s.WholeSalePrice) delete data.wholesale_price;
    if (!s.RetailPrice) delete data.retail_price;
    if (!s.RetailWirePrice) delete data.retailwire_price;
    if (!s.warentypaperset) delete data.warranty_paper;
    if (!s.archivePaperSet) delete data.archive;
    if (!s.isService) delete data.is_service;
    if (!s.serviceDate) delete data.service_date;
    if (!s.PurchasedDate1) delete data.warranty_date;
    if (!s.archiveDate) delete data.archive_date;
    if (!s.total_cost) delete data.total_cost;
    if (!s.tag_price) delete data.tag_price;
    if (!s.purchase_expense) delete data.purchase_expense;
    if (!s.purchase_expense_note) delete data.purchase_expense_note;
    if (!s.locationSearch) delete data.inventory_location;
    if (!s.public_dealer_note) delete data.public_dealer_note;
    if (!s.inventory_status) delete data.inventory_status;
    if (!s.MemoDetails) delete data.memo_details;
    if (!s.updatememo) delete data.memo_number;
    if (!s.updatepartnershipnumber) delete data.partnership_number;
    if (!s.PartnershipDetails) delete data.partnership_detais;
    if (!s.modification_deatils) delete data.modification_deatils;
    if (!data.purchase_payment_date || !s.paymentDate || !s.paidStatus) delete data.purchase_payment_date;
    if (!data.purchase_payment_duedate || !s.purchaseDueDate || s.paidStatus) delete data.purchase_payment_duedate;
    if (!s.purchaseFromContactId) delete data.purchasefromcontactid;
    if (!s.memoContactId) delete data.memocontactid;
    if (!s.partnerContactId) delete data.partnercontactid;

    const formData = new FormData();
    s.invoiceFiles.forEach(({ file }) => formData.append("image", file));
    for (const key in data) formData.set(key, data[key]);

    addMiscInventoryData(formData, (error, res) => {
      setState({ isSubmitting: false });
      if (error) {
        toast(error?.response?.data?.message || error?.message || "Inventory creation failed", {
          autoClose: 2000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      } else if (res?.success === 0 && res?.data?.isLimitExited) {
        setState({ limitReachedModalOpen: true });
      } else {
        if (res?.data?.inventoryid) uploadInventoryMedia(res.data.inventoryid);
        if (typeof props.submitted === "function") props.submitted(res?.data?.inventoryid);
        localStorage.removeItem("warranty_box");
        setState({ inventoryid: res?.data });
        props.history.push("/myinventory");
        setTimeout(() => window.scrollTo(0, 0), 50);
      }
    });
  };

  const submitMiscProduct = () => {
    const s = stateRef.current;

    if (!s.miscProductModelName || !s.miscProductModelName.trim()) {
      setState({ onMiscProductModelNameErrorText: "Enter the Model Name" });
      const errorEl = document.getElementById("miscProductModelName");
      if (errorEl) {
        errorEl.scrollIntoView({ behavior: "smooth", block: "center" });
        errorEl.focus();
      }
      return;
    }

    const x = localStorage.getItem("warranty_box");
    setState({ isSubmitting: true });

    const miscProductInventoryTitleValue = typeof s.miscProductInventoryTitle === "string"
      ? s.miscProductInventoryTitle.trim()
      : "";

    const attributes = {
      product_name: s.miscProductModelName || "",
      ...(miscProductInventoryTitleValue ? { product_title: miscProductInventoryTitleValue } : {}),
      brand_name: s.brand_name || "",
      model_number: s.miscProductData.modelNumber || "",
      description: s.miscProductData.description || "",
    };

    const data = {
      technical_details: JSON.stringify(attributes),
      accountId: s.accountId,
      purchase_price: s.raw_PurchasedPrice || "",
      purchase_date: s.PurchasedDate || "",
      purchase_from: s.PurchasedFrom || "",
      quantity: s.miscProductData.quantity || "1",
      serial_no: s.miscProductData.serialNumber || "",
      inventory_type: s.inventory_type || "",
      memo_details: s.MemoDetails || "",
      partnership_detais: s.PartnershipDetails || "",
      condition: s.Condition || "1",
      band_size: s.BandSize || "",
      links: s.raw_NumberOfLinks || "",
      note: s.DealerNotes || "",
      wholesale_price: s.raw_Wholesale_Price || "",
      retail_price: s.raw_Retail_Price || "",
      retailwire_price: s.raw_Retail_Wireprice || "",
      warranty_paper: s.warentypaperset || "",
      archive: s.archivePaperSet || "",
      is_service: s.isService || "",
      service_date: s.serviceDate || "",
      warranty_box: x || "0",
      warranty_date: s.PurchasedDate1 || "",
      archive_date: s.archiveDate || "",
      inventory_status: s.inventory_status || "",
      public_dealer_note: s.public_dealer_note || "",
      memo_number: s.updatememo || "",
      partnership_number: s.updatepartnershipnumber || null,
      total_cost: s.raw_total_cost || "",
      tag_price: s.raw_tag_price || "",
      modification_deatils: s.modification_deatils || "",
      ismodified: s.ismodified || false,
      purchase_expense: s.raw_PurchasedExpense || "",
      purchase_invoice_paid: s.paidStatus || false,
      purchase_payment_date: s.paymentDate || null,
      purchase_payment_details: s.PaymentDetailsText || "",
      purchase_payment_duedate: s.purchaseDueDate || null,
      purchase_expense_note: s.purchase_expense_note || "",
      paperType: s.typeOfPaper || null,
      inventory_location: s.locationSearch || "",
      type: "misc_product",
      category: s.InventoryType ? s.InventoryType.toLowerCase() : null,
      is_include_dealerfeed: s.dealerInv,
      is_include_shopify: s.shopifyConfig,
      is_include_ebayconfig: s.ebayConfig,
      purchasefromcontactid: s.purchaseFromContactId || null,
      memocontactid: s.memoContactId || null,
      partnercontactid: s.partnerContactId || null,
    };

    if (miscProductInventoryTitleValue) {
      data.inventory_title = miscProductInventoryTitleValue;
    } else {
      delete data.inventory_title;
    }

    if (!s.PurchasedPrice) delete data.purchase_price;
    if (!s.PurchasedDate) delete data.purchase_date;
    if (!s.PurchasedFrom) delete data.purchase_from;
    if (!s.BandSize) delete data.band_size;
    if (!s.NumberOfLinks) delete data.links;
    if (!s.DealerNotes) delete data.note;
    if (!s.WholeSalePrice) delete data.wholesale_price;
    if (!s.RetailPrice) delete data.retail_price;
    if (!s.RetailWirePrice) delete data.retailwire_price;
    if (!s.warentypaperset) delete data.warranty_paper;
    if (!s.archivePaperSet) delete data.archive;
    if (!s.isService) delete data.is_service;
    if (!s.serviceDate) delete data.service_date;
    if (!s.PurchasedDate1) delete data.warranty_date;
    if (!s.archiveDate) delete data.archive_date;
    if (!s.total_cost) delete data.total_cost;
    if (!s.tag_price) delete data.tag_price;
    if (!s.purchase_expense) delete data.purchase_expense;
    if (!s.purchase_expense_note) delete data.purchase_expense_note;
    if (!s.locationSearch) delete data.inventory_location;
    if (!s.public_dealer_note) delete data.public_dealer_note;
    if (!s.inventory_status) delete data.inventory_status;
    if (!s.MemoDetails) delete data.memo_details;
    if (!s.updatememo) delete data.memo_number;
    if (!s.updatepartnershipnumber) delete data.partnership_number;
    if (!s.PartnershipDetails) delete data.partnership_detais;
    if (!s.modification_deatils) delete data.modification_deatils;
    if (!data.purchase_payment_date || !s.paymentDate || !s.paidStatus) delete data.purchase_payment_date;
    if (!data.purchase_payment_duedate || !s.purchaseDueDate || s.paidStatus) delete data.purchase_payment_duedate;
    if (!s.purchaseFromContactId) delete data.purchasefromcontactid;
    if (!s.memoContactId) delete data.memocontactid;
    if (!s.partnerContactId) delete data.partnercontactid;

    const formData = new FormData();
    s.invoiceFiles.forEach(({ file }) => formData.append("image", file));
    for (const key in data) formData.set(key, data[key]);

    addMiscInventoryData(formData, (error, res) => {
      setState({ isSubmitting: false });
      if (error) {
        toast(error?.response?.data?.message || error?.message || "Inventory creation failed", {
          autoClose: 2000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      } else if (res?.success === 0 && res?.data?.isLimitExited) {
        setState({ limitReachedModalOpen: true });
      } else {
        if (res?.data?.inventoryid) uploadInventoryMedia(res.data.inventoryid);
        if (typeof props.submitted === "function") props.submitted(res?.data?.inventoryid);
        localStorage.removeItem("warranty_box");
        setState({ inventoryid: res?.data });
        props.history.push("/myinventory");
        setTimeout(() => window.scrollTo(0, 0), 50);
      }
    });
  };
  const { searchItems, cursor } = state;
  const labelStyle = {
    display: "inline-block",
    width: "160px",
    fontWeight: "bold",
    verticalAlign: "top",
  };
  const valueStyle = {
    display: "inline-block",
    width: "calc(100% - 168px)",
    verticalAlign: "top",
    wordBreak: "break-word",
  };
  const { minmax_pricelist } = state;

  const hasPurchaseRange =
    minmax_pricelist &&
    minmax_pricelist.min_inventory_cost != null &&
    minmax_pricelist.max_inventory_cost != null &&
    !(Number(minmax_pricelist.min_inventory_cost) === 0 && Number(minmax_pricelist.max_inventory_cost) === 0);

  const hasSellingRange =
    minmax_pricelist &&
    minmax_pricelist.min_invoice_cost != null &&
    minmax_pricelist.max_invoice_cost != null &&
    !(Number(minmax_pricelist.min_invoice_cost) === 0 && Number(minmax_pricelist.max_invoice_cost) === 0);

  const purchaseRange = hasPurchaseRange
    ? Number(minmax_pricelist.min_inventory_cost) === 0
      ? formatCurrency(minmax_pricelist.max_inventory_cost)
      : `${formatCurrency(minmax_pricelist.min_inventory_cost)} - ${formatCurrency(minmax_pricelist.max_inventory_cost)}`
    : "N/A";

  const sellingRange = hasSellingRange
    ? Number(minmax_pricelist.min_invoice_cost) === 0
      ? formatCurrency(minmax_pricelist.max_invoice_cost)
      : `${formatCurrency(minmax_pricelist.min_invoice_cost)} - ${formatCurrency(minmax_pricelist.max_invoice_cost)}`
    : "N/A";

  const inventoryPage = () => (
    <div className="space-1 ai-page">
      {state.loaded == false ? (
        <div className="d-spinner">
          <SpinnerRoundFilled
            size={51}
            thickness={125}
            speed={80}
            color="rgba(57, 107, 172, 1)"
            className="spp"
            enabled={state.loaded == false}
          />
        </div>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            submitForm(e);
          }}
          id="add_inventory_form"
        >
          <Container maxWidth="xl" className="ai-container">
            <div className="ai-topbar">
              <div className="ai-topbar__left">
                <div>
                  <p className="ai-topbar__title">ADD INVENTORY</p>
                  <p className="ai-topbar__subtitle">Add accurate details to manage your inventory effectively.</p>
                </div>
              </div>
            </div>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <div className="ai-col">
                  <SectionCard icon={<InfoOutlinedIcon />} title="BASIC INFORMATION">
                    <FormControl fullWidth className="ai-field">
                      <FieldLabel required>Inventory</FieldLabel>
                      <Select
                        displayEmpty
                        className="ai-select"
                        value={state.InventoryType}
                        onChange={handleWatchTypeChange}
                        renderValue={(value) => {
                          if (value == null || value === "" || value === "misc-watch") {
                            return "Watch";
                          }
                          const labels = {
                            "": "Watch",
                            "misc-watch": "Misc Watch",
                            "watch related accessories": "Watch Related Accessories",
                            apparel: "Apparel",
                            "watch parts": "Watch Parts",
                            jewelry: "Jewelry",
                            stones: "Stones",
                            "hand bags": "Hand Bags",
                            wallets: "Wallets",
                            "bag related accessories": "Bag Related Accessories",
                            "service watches": "Service Watches",
                            others: "Others",
                          };
                          return labels[value] || "Watch";
                        }}
                      >
                        <MenuItem value="">
                          Watch
                        </MenuItem>
                        <MenuItem
                          value="misc-watch"
                          style={{ display: "none" }}
                        >
                          Misc Watch
                        </MenuItem>
                        <MenuItem value="watch related accessories">Watch Related Accessories</MenuItem>
                        <MenuItem value="apparel">Apparel</MenuItem>
                        <MenuItem value="watch parts">Watch Parts</MenuItem>
                        <MenuItem value="jewelry">Jewelry</MenuItem>
                        <MenuItem value="stones">Stones</MenuItem>
                        <MenuItem value="hand bags">Hand Bags</MenuItem>
                        <MenuItem value="wallets">Wallets</MenuItem>
                        <MenuItem value="bag related accessories">Bag Related Accessories</MenuItem>
                        <MenuItem value="service watches">Service Watches</MenuItem>
                        <MenuItem value="others">Others</MenuItem>
                      </Select>
                    </FormControl>
                    {/* Standard Watch */}
                    {state.InventoryType === "" && (
                      <FormControl fullWidth className="ai-field">
                        <FieldLabel required>
                          SEARCH WATCHES
                        </FieldLabel>

                        <Input
                          disableUnderline
                          className="ai-input"
                          placeholder="SEARCH WATCHES"
                          id="autocomplete"
                          onChange={autocomplete}
                          onKeyUp={hanldeKeyup}
                          onKeyDown={hanldeKeydown}
                          value={state.searchString}
                          endAdornment={
                            <InputAdornment position="end">
                              {state.loading ? (
                                <CircularProgress
                                  style={{
                                    width: 18,
                                    height: 18,
                                  }}
                                />
                              ) : (
                                <IconButton
                                  size="small"
                                  onClick={editinvnetrydeatils}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              )}
                            </InputAdornment>
                          }
                        />

                        {state.autocomplete.data.length > 1 &&
                          state.individualsearchdata && (
                            <div className="autocomplete-box">

                              <div className="watch-results">
                                <List className="searchlist inventrysearch">
                                  {state.autocomplete.data.map((item, idx) => (
                                    <div key={idx}>
                                      <ListItem
                                        onClick={() =>
                                          onchangeModelNumber(
                                            item,
                                            item.productId
                                          )
                                        }
                                      >
                                        <ListItemIcon>
                                          <IconButton color="primary">
                                            <img
                                              width="45"
                                              src={
                                                item.imagepaths?.images
                                                  ?.toString()
                                                  .split(",")[0]
                                              }
                                              alt="Product"
                                            />
                                          </IconButton>
                                        </ListItemIcon>

                                        <ListItemText
                                          primary={
                                            item.brandname + " " + item.model
                                          }
                                          secondary={item.family}
                                        />
                                      </ListItem>

                                      <Divider />
                                    </div>
                                  ))}
                                </List>
                              </div>

                              <div
                                className="misc-watch-option"
                                onClick={() => {
                                  setState({
                                    InventoryType: "misc-watch",

                                    searchString: "",
                                    ModelNumber: "",
                                    inventory_title: "",
                                    IndividualBrowseWatchesData: [],
                                    selectedProduct: {},
                                    autocomplete: { data: [] },
                                    searchItems: [],
                                    individualsearchdata: false,

                                    miscWatchData: {
                                      modelName: "",
                                      brand: "",
                                      modelNumber: "",
                                      caseMaterial: "",
                                      caseSize: "",
                                      dialColor: "",
                                      bandMaterial: "",
                                    },
                                  });
                                  loadMiscWatchData();
                                }}
                              >
                                Create New Watch
                              </div>

                            </div>
                          )}
                        <FormHelperText className="error-o">
                          {state.onModelNumberErrorText}
                        </FormHelperText>
                      </FormControl>
                    )}
                    {state.searchString && (
                      <Card className="ai-tech-card">
                        <CardContent>
                          <Typography className="ai-tech-card__title">TECHNICAL DETAILS</Typography>
                          <Typography>
                            <b style={labelStyle}>Model Name</b>
                            <span style={valueStyle}>
                              : {state.IndividualBrowseWatchesData && state.IndividualBrowseWatchesData.prodattr
                                ? state.IndividualBrowseWatchesData.prodattr.model
                                : "-"}
                            </span>
                            <br />
                            <b style={labelStyle}>Brand Name</b>
                            <span style={valueStyle}>
                              : {state.IndividualBrowseWatchesData && state.IndividualBrowseWatchesData.brandname
                                ? state.IndividualBrowseWatchesData.brandname
                                : "-"}
                            </span>
                            <br />
                            <b style={labelStyle}>Model Number</b>
                            <span style={valueStyle}>
                              : {state.IndividualBrowseWatchesData && state.IndividualBrowseWatchesData.prodattr
                                ? state.IndividualBrowseWatchesData.prodattr.reference
                                : "-"}
                            </span>
                            <br />
                            <b style={labelStyle}>Case Material</b>
                            <span style={valueStyle}>
                              : {state.IndividualBrowseWatchesData && state.IndividualBrowseWatchesData.prodattr
                                ? state.IndividualBrowseWatchesData.prodattr.casematerial
                                : "-"}
                            </span>
                            <br />
                            <b style={labelStyle}>Case Size</b>
                            <span style={valueStyle}>
                              : {state.IndividualBrowseWatchesData && state.IndividualBrowseWatchesData.prodattr
                                ? state.IndividualBrowseWatchesData.prodattr.casesize
                                : "-"}
                            </span>
                            <br />
                            <b style={labelStyle}>Dial Color</b>
                            <span style={valueStyle}>
                              : {state.IndividualBrowseWatchesData && state.IndividualBrowseWatchesData.prodattr
                                ? state.IndividualBrowseWatchesData.prodattr.dialcolor
                                : "-"}
                            </span>
                            <br />
                            <b style={labelStyle}>Band Material</b>
                            <span style={valueStyle}>
                              : {state.IndividualBrowseWatchesData && state.IndividualBrowseWatchesData.prodattr
                                ? state.IndividualBrowseWatchesData.prodattr.bandmaterial
                                : "-"}
                            </span>
                            <br />
                            <b style={labelStyle}>Retail Price</b>
                            <span style={valueStyle}>: {state.retailAmount || "-"}</span>
                            <br />
                            <b style={labelStyle}>Purchase Range</b>
                            <span style={valueStyle}>: {purchaseRange}</span>
                            <br />
                            <b style={labelStyle}>Selling Range</b>
                            <span style={valueStyle}>: {sellingRange}</span>
                            <br />
                            <Typography className="additionalDetails" onClick={toggleAdditionalDetails}>
                              Additional Details
                              {state.showAdditionalDetails ? (
                                <KeyboardArrowUpIcon style={{ fontSize: "16px" }} />
                              ) : (
                                <KeyboardArrowDownIcon style={{ fontSize: "16px" }} />
                              )}
                            </Typography>
                            {state.showAdditionalDetails && (
                              <CardContent style={{ padding: "5px 0px 8px 0px" }}>
                                <div style={{ marginLeft: "0px" }}>
                                  <b style={labelStyle}>Index Type</b>
                                  <span style={valueStyle}>
                                    : {state.IndividualBrowseWatchesData?.prodattr?.indices || "-"}
                                  </span>
                                  <br />
                                  <b style={labelStyle}>Buckle Type</b>
                                  <span style={valueStyle}>
                                    : {state.IndividualBrowseWatchesData?.prodattr?.buckletype || "-"}
                                  </span>
                                  <br />
                                  <b style={labelStyle}>Bezel</b>
                                  <span style={valueStyle}>
                                    : {state.IndividualBrowseWatchesData?.prodattr?.bezel || "-"}
                                  </span>
                                  <br />
                                  <b style={labelStyle}>Band Color</b>
                                  <span style={valueStyle}>
                                    : {state.IndividualBrowseWatchesData?.prodattr?.bandcolor || "-"}
                                  </span>
                                  <br />
                                </div>
                              </CardContent>
                            )}
                          </Typography>
                        </CardContent>
                      </Card>
                    )}
                    {/* standard watch */}
                    {state.InventoryType === "" && (
                      <FormControl fullWidth className="ai-field">
                        <FieldLabel>Inventory Title</FieldLabel>
                        <Input
                          disableUnderline
                          className="ai-input"
                          placeholder="Inventory Title"
                          id="autocomplete"
                          onChange={autocomplete}
                          onKeyUp={hanldeKeyup}
                          onKeyDown={hanldeKeydown}
                          disabled={state.disbleseach === true}
                          value={state.searchString}
                        />
                      </FormControl>
                    )}
                    {state.InventoryType === "" && (
                      <FormControl fullWidth className="ai-field">
                        <FieldLabel required>Serial Number</FieldLabel>

                        <Input
                          disableUnderline
                          className="ai-input"
                          placeholder="Enter serial number"
                          id="serialNumber"
                          onChange={onchangeSerialNumber}
                          value={state.SerialNumber}
                        />

                        <FormHelperText className="error-o">
                          {state.onSerialNumberErrorText}
                        </FormHelperText>
                      </FormControl>
                    )}
                    {/* Misc Product */}
                    {MISC_PRODUCT_TYPES.includes(state.InventoryType) && (
                      <Grid container spacing={2} className="ai-misc-grid">
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel required>
                              Model Name
                            </FieldLabel>

                            <Input
                              disableUnderline
                              id="miscProductModelName"
                              className="ai-input"
                              placeholder="Model Name"
                              value={state.miscProductModelName || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                const nextModelName = value || "";
                                if (!nextModelName.trim()) {
                                  miscProductTitleManuallyEdited.current = false;
                                  setState({
                                    miscProductModelName: "",
                                    miscProductInventoryTitle: "",
                                    onMiscProductModelNameErrorText: "",
                                  });
                                  return;
                                }

                                setState({
                                  miscProductModelName: nextModelName,
                                  onMiscProductModelNameErrorText: "",
                                });

                                if (!miscProductTitleManuallyEdited.current) {
                                  setState({
                                    miscProductInventoryTitle: getNextMiscProductInventoryTitle({
                                      modelName: nextModelName,
                                      currentInventoryTitle: stateRef.current.miscProductInventoryTitle,
                                      wasInventoryTitleManuallyCleared: miscProductTitleManuallyEdited.current,
                                    }),
                                  });
                                }
                              }}
                            />
                            <FormHelperText className="error-o">
                              {state.onMiscProductModelNameErrorText}
                            </FormHelperText>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>Inventory Title</FieldLabel>
                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Inventory Title"
                              id="autocomplete"
                              id="component-simple"
                              onChange={(event) => {
                                const nextValue = event.target.value;
                                miscProductTitleManuallyEdited.current = true;
                                setState({ miscProductInventoryTitle: nextValue });
                              }}
                              value={state.miscProductInventoryTitle ?? ""}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>
                              Description
                            </FieldLabel>

                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Description"
                              value={state.miscProductData.description}
                              onChange={(e) =>
                                setState({
                                  miscProductData: {
                                    ...state.miscProductData,
                                    description: e.target.value,
                                  },
                                })
                              }
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>
                              Brand
                            </FieldLabel>

                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Brand"
                              value={state.brand_name || ""}
                              onChange={onchangeBrandName}
                            />

                            {state.brandloading ? (
                              <CircularProgress size={20} />
                            ) : state.brandAutoCompleteData?.data?.length > 0 ? (
                              <List
                                className="searchlist MuiPaper-elevation1 inventrysearch"
                                style={{
                                  listStyle: "none",
                                  margin: 0,
                                  padding: 0,
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  width: "100%",
                                  zIndex: 10,
                                }}
                              >
                                {state.brandAutoCompleteData.data.map((item, idx) => (
                                  <ListItem
                                    key={idx}
                                    button
                                    className={cursor === idx ? "active" : ""}
                                    onClick={() => onchangebrand(item)}
                                    style={{ paddingTop: 4, paddingBottom: 4 }}
                                  >
                                    <ListItemText
                                      primary={item.brandname}
                                      style={{ margin: 0 }}
                                    />
                                  </ListItem>
                                ))}
                              </List>
                            ) : null}
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>
                              Model Number
                            </FieldLabel>

                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Model Number"
                              value={state.miscProductData.modelNumber}
                              onChange={(e) =>
                                setState({
                                  miscProductData: {
                                    ...state.miscProductData,
                                    modelNumber: e.target.value,
                                  },
                                })
                              }
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>
                              Quantity
                            </FieldLabel>

                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Quantity"
                              value={state.miscProductData.quantity}
                              disabled
                              onChange={(e) =>
                                setState({
                                  miscProductData: {
                                    ...state.miscProductData,
                                    quantity: e.target.value,
                                  },
                                })
                              }
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>
                              Serial Number
                            </FieldLabel>

                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Serial Number"
                              value={state.miscProductData.serialNumber}
                              onChange={(e) =>
                                setState({
                                  miscProductData: {
                                    ...state.miscProductData,
                                    serialNumber: e.target.value,
                                  },
                                })
                              }
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                    )}

                    {/* Misc Watch */}
                    {state.InventoryType === "misc-watch" && (
                      <Grid container spacing={2} className="ai-misc-grid">
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>Model Name</FieldLabel>

                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Model Name"
                              value={state.miscWatchModelName || ""}
                              onChange={handleMiscWatchModelNameChange}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>Inventory Title</FieldLabel>

                            <Input
                              className="ai-input"
                              placeholder="Inventory Title"
                              id="component-simple"
                              onChange={handleMiscWatchInventoryTitleChange}
                              value={state.miscWatchInventoryTitle || ""}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>
                              Brand
                            </FieldLabel>

                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Brand"
                              value={state.brand_name || ""}
                              onChange={onchangeBrandName}
                            />

                            {state.brandloading ? (
                              <CircularProgress size={20} />
                            ) : state.brandAutoCompleteData?.data?.length > 0 ? (
                              <List
                                className="searchlist MuiPaper-elevation1 inventrysearch"
                                style={{
                                  listStyle: "none",
                                  margin: 0,
                                  padding: 0,
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  width: "100%",
                                  zIndex: 10,
                                }}
                              >
                                {state.brandAutoCompleteData.data.map((item, idx) => (
                                  <ListItem
                                    key={idx}
                                    button
                                    className={cursor === idx ? "active" : ""}
                                    onClick={() => onchangebrand(item)}
                                    style={{ paddingTop: 4, paddingBottom: 4 }}
                                  >
                                    <ListItemText
                                      primary={item.brandname}
                                      style={{ margin: 0 }}
                                    />
                                  </ListItem>
                                ))}
                              </List>
                            ) : null}
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>
                              Model Number
                            </FieldLabel>

                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Model Number"
                              value={state.miscWatchData.modelNumber}
                              onChange={(e) =>
                                setState({
                                  miscWatchData: {
                                    ...state.miscWatchData,
                                    modelNumber: e.target.value,
                                  },
                                })
                              }
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>
                              Case Material
                            </FieldLabel>

                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Case Material"
                              // value={state.miscWatchData.caseMaterialMaterial || ""}
                              value={state.case_material || ""}
                              onChange={onchangeCaseMaterial}
                            />

                            {state.caseMaterialloading ? (
                              <CircularProgress size={20} />
                            ) : state.caseMaterialAutoCompleteData?.data?.length > 0 ? (
                              <List
                                className="searchlist MuiPaper-elevation1 inventrysearch"
                                style={{
                                  listStyle: "none",
                                  margin: 0,
                                  padding: 0,
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  width: "100%",
                                  zIndex: 10,
                                }}
                              >
                                {state.caseMaterialAutoCompleteData.data.map((item, idx) => (
                                  <ListItem
                                    key={idx}
                                    button
                                    className={cursor === idx ? "active" : ""}
                                    onClick={() => onchangecasematerial(item)}
                                    style={{ paddingTop: 4, paddingBottom: 4 }}
                                  >
                                    <ListItemText
                                      primary={item.casematerial}
                                      style={{ margin: 0 }}
                                    />
                                  </ListItem>
                                ))}
                              </List>
                            ) : null}
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>
                              Case Size
                            </FieldLabel>

                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Case Size"
                              value={state.miscWatchData.caseSize}
                              onChange={(e) =>
                                setState({
                                  miscWatchData: {
                                    ...state.miscWatchData,
                                    caseSize: e.target.value,
                                  },
                                })
                              }
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>
                              Dial Color
                            </FieldLabel>

                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Dial Color"
                              value={state.miscWatchData.dialColor}
                              onChange={(e) =>
                                setState({
                                  miscWatchData: {
                                    ...state.miscWatchData,
                                    dialColor: e.target.value,
                                  },
                                })
                              }
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>
                              Band Material
                            </FieldLabel>

                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Band Material"
                              // value={state.miscWatchData.bandMaterial}
                              value={state.band_material || ""}
                              onChange={onchangeBandMaterial}
                            />
                            {state.bandMaterialloading ? (
                              <CircularProgress size={20} />
                            ) : state.bandMaterialAutoCompleteData?.data?.length > 0 ? (
                              <List
                                className="searchlist MuiPaper-elevation1 inventrysearch"
                                style={{
                                  listStyle: "none",
                                  margin: 0,
                                  padding: 0,
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  width: "100%",
                                  zIndex: 10,
                                }}
                              >
                                {state.bandMaterialAutoCompleteData.data.map((item, idx) => (
                                  <ListItem
                                    key={idx}
                                    button
                                    className={cursor === idx ? "active" : ""}
                                    onClick={() => onchangebandmaterial(item)}
                                    style={{ paddingTop: 4, paddingBottom: 4 }}
                                  >
                                    <ListItemText
                                      primary={item.bandmaterial}
                                      style={{ margin: 0 }}
                                    />
                                  </ListItem>
                                ))}
                              </List>
                            ) : null}
                          </FormControl>
                        </Grid>
                      </Grid>
                    )}
                    {/* Standard Watch */}
                    {state.InventoryType === "" && (
                      <>
                        {(isActionAllowed(state.viewData, "purchase_from") ||
                          isActionAllowed(state.viewData, "purchase_date")) && (
                            <Grid container spacing={2}>

                              {isActionAllowed(state.viewData, "purchase_from") && (
                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>
                                      Purchased From
                                    </FieldLabel>

                                    <div className="ai-input-icon-wrap">
                                      <AntdInput
                                        id="PurchasedFrom"
                                        type="text"
                                        autoComplete="off"
                                        className="ai-antd-input"
                                        placeholder="Search dealer or source"
                                        value={state.PurchasedFrom}
                                        onChange={(e) =>
                                          onchangeContactSuggestion(
                                            e,
                                            "PurchasedFrom",
                                            ["supplier", "memo_supplier"]
                                          )
                                        }
                                        bordered={false}
                                      />

                                      <span className="ai-input-icon-wrap__icon">
                                        {!state.PurchasedFrom ? (
                                          <SearchIcon
                                            style={{ cursor: "pointer" }}
                                            fontSize="small"
                                          />
                                        ) : state.fieldLoader ? (
                                          <CircularProgress
                                            style={{
                                              width: 18,
                                              height: 18,
                                            }}
                                          />
                                        ) : (
                                          <ClearIcon
                                            id="clearBtn"
                                            onClick={() =>
                                              clearContactSuggestion("PurchasedFrom")
                                            }
                                            style={{ cursor: "pointer" }}
                                            fontSize="small"
                                          />
                                        )}
                                      </span>
                                    </div>

                                    {state.purchasedFromArray &&
                                      state.purchasedFromArray.length > 0 &&
                                      state.PurchasedFrom?.length > 0 ? (
                                      <AntdPopover
                                        visible={state.isPopOverPurchasedFrom}
                                        content={
                                          <div
                                            style={{
                                              height: "200px",
                                              overflow: "auto",
                                            }}
                                          >
                                            {state.dataset?.slice(0, 15).map((value, key) =>
                                              value.map((el, index) => {
                                                if (index < 1) {
                                                  return (
                                                    <React.Fragment key={index}>
                                                      {state.purchasedFromArray
                                                        ?.filter(
                                                          (v) => v.email == el.email
                                                        )
                                                        .map((el, index) => (
                                                          <AccordionDetails key={index}>
                                                            <Typography
                                                              style={{
                                                                cursor: "pointer",
                                                              }}
                                                              onClick={() =>
                                                                handleContactSelection(
                                                                  el,
                                                                  "PurchasedFrom"
                                                                )
                                                              }
                                                            >
                                                              {handleContact(el)}
                                                            </Typography>
                                                          </AccordionDetails>
                                                        ))}
                                                    </React.Fragment>
                                                  );
                                                }

                                                return null;
                                              })
                                            )}
                                          </div>
                                        }
                                        trigger="click"
                                        placement="bottomRight"
                                        onVisibleChange={handleVisibleChange}
                                      >
                                        <div
                                          style={{
                                            width: 0,
                                            height: 0,
                                            position: "absolute",
                                          }}
                                        />
                                      </AntdPopover>
                                    ) : (
                                      state.PurchasedFrom.length > 2 &&
                                      !state.purchasedFromArray.length &&
                                      !state.fieldLoader && (
                                        <AntdPopover
                                          visible={
                                            state.PurchasedFrom?.length > 2 &&
                                            !state.purchasedFromArray.length &&
                                            !state.fieldLoader
                                          }
                                          content={
                                            <div style={{ overflow: "auto" }}>
                                              <a
                                                className="dataItem"
                                                href="javascript:void(0)"
                                                onClick={() => {
                                                  const typeData = [
                                                    {
                                                      id: "supplier",
                                                      value: "Supplier",
                                                    },
                                                    {
                                                      id: "memo_supplier",
                                                      value: "Memo Supplier",
                                                    },
                                                  ];

                                                  const encodedTypeData =
                                                    btoa(
                                                      JSON.stringify(typeData)
                                                    );

                                                  window.open(
                                                    `/contactmanagement/add?type=${encodedTypeData}`,
                                                    "_blank"
                                                  );
                                                }}
                                                style={{
                                                  cursor: "pointer",
                                                  textDecoration: "underline",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                Click here to Create New Contact
                                              </a>
                                            </div>
                                          }
                                          trigger="click"
                                          placement="bottomRight"
                                          overlayStyle={{
                                            marginTop: "5px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              width: 0,
                                              height: 0,
                                              position: "absolute",
                                            }}
                                          />
                                        </AntdPopover>
                                      )
                                    )}
                                  </FormControl>
                                </Grid>
                              )}

                              {isActionAllowed(state.viewData, "purchase_date") && (
                                <Grid item xs={12} sm={6}>
                                  <FormControl fullWidth className="ai-field">
                                    <FieldLabel>
                                      Purchased Date
                                    </FieldLabel>

                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                      <KeyboardDatePicker
                                        className="ai-datepicker"
                                        margin="normal"
                                        id="date-picker-dialog"
                                        format="MM/dd/yyyy"
                                        disableFuture
                                        value={state.PurchasedDate || null}
                                        onChange={handleDateChange}
                                        KeyboardButtonProps={{
                                          "aria-label": "change date",
                                        }}
                                        placeholder="MM/DD/YYYY"
                                        onPaste={(event) =>
                                          event.preventDefault()
                                        }
                                        helperText={
                                          state.error["PD"]
                                            ? "Invalid date"
                                            : ""
                                        }
                                        error={state.error["PD"]}
                                      />
                                    </MuiPickersUtilsProvider>

                                    <FormHelperText className="error-o">
                                      {state.onPurchasedDateErrorText}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                              )}
                            </Grid>
                          )}

                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>Purchase Payment Status</FieldLabel>

                              <Select
                                disableUnderline
                                className="ai-select"
                                value={state.paidStatus ? "paid" : "unpaid"}
                                onChange={(e) =>
                                  handlePaidStatusCheck({
                                    target: {
                                      checked: e.target.value === "paid",
                                    },
                                  })
                                }
                                renderValue={(val) => (
                                  <span className="ai-status-pill">
                                    <span className="ai-status-pill__dot" />
                                    {val === "paid" ? "Paid" : "Unpaid"}
                                  </span>
                                )}
                              >
                                <MenuItem value="paid">Paid</MenuItem>
                                <MenuItem value="unpaid">Unpaid</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>
                                {state.paidStatus
                                  ? "Purchase Payment Date"
                                  : "Purchase Payment Due Date"}
                              </FieldLabel>

                              {state.paidStatus ? (
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <KeyboardDatePicker
                                    key="paid-date-picker"
                                    className="ai-datepicker"
                                    margin="normal"
                                    id="date-picker-purchase"
                                    format="MM/dd/yyyy"
                                    disableFuture
                                    value={state.paymentDate || null}
                                    onChange={handlePayDateChange}
                                    KeyboardButtonProps={{
                                      "aria-label": "change date",
                                    }}
                                    placeholder="MM/DD/YYYY"
                                    onPaste={(event) => event.preventDefault()}
                                    helperText={
                                      state.error["PPD"] ? "Invalid date" : ""
                                    }
                                    error={state.error["PPD"]}
                                  />
                                </MuiPickersUtilsProvider>
                              ) : (
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <KeyboardDatePicker
                                    key="due-date-picker"
                                    className="ai-datepicker"
                                    margin="normal"
                                    id="date-picker-dialog"
                                    format="MM/dd/yyyy"
                                    value={state.purchaseDueDate || null}
                                    onChange={handleDueDateChange}
                                    KeyboardButtonProps={{
                                      "aria-label": "change date",
                                    }}
                                    placeholder="MM/DD/YYYY"
                                    onPaste={(event) => event.preventDefault()}
                                    helperText={
                                      state.error["PPDD"]
                                        ? "Invalid date"
                                        : ""
                                    }
                                    error={state.error["PPDD"]}
                                  />
                                </MuiPickersUtilsProvider>
                              )}

                              <FormHelperText className="error-o">
                                {state.onpaymentDateErrorText}
                              </FormHelperText>
                            </FormControl>
                          </Grid>
                        </Grid>

                        <FormControl fullWidth className="ai-field">
                          <FieldLabel>Purchase Payment Details</FieldLabel>

                          <Input
                            disableUnderline
                            className="ai-input ai-input--textarea"
                            placeholder="Enter payment details"
                            multiline
                            onChange={onchangePaymentDetails}
                            value={state.PaymentDetailsText || ""}
                          />

                          <FormHelperText className="error-o">
                            {state.onPaymentDetailsErrorText}
                          </FormHelperText>
                        </FormControl>

                        <Grid container spacing={2}>
                          {isActionAllowed(state.viewData, "purchase_price") && (
                            <Grid item xs={12} sm={6}>
                              <FormControl fullWidth className="ai-field">
                                <FieldLabel>Purchased Price ($)</FieldLabel>

                                <Input
                                  disableUnderline
                                  className="ai-input"
                                  placeholder="0.00"
                                  onChange={onchangePurchasedPrice}
                                  value={state.PurchasedPrice}
                                />

                                <FormHelperText className="error-o">
                                  {state.onPurchasedPriceErrorText}
                                </FormHelperText>
                              </FormControl>
                            </Grid>
                          )}

                          {isActionAllowed(state.viewData, "purchase_expense") && (
                            <Grid item xs={12} sm={6}>
                              <FormControl fullWidth className="ai-field">
                                <FieldLabel>Purchase Expense ($)</FieldLabel>

                                <Input
                                  disableUnderline
                                  className="ai-input"
                                  placeholder="0.00"
                                  onChange={onchangePurchaseExpense}
                                  value={state.purchase_expense}
                                />
                              </FormControl>
                            </Grid>
                          )}

                        </Grid>

                        {isActionAllowed(state.viewData, "purchase_expense") && (
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>Purchase Expense Note</FieldLabel>

                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Enter expense note"
                              onChange={onchangePurchaseExpenseNote}
                            />
                          </FormControl>
                        )}

                        {isActionAllowed(state.viewData, "total_cost") && (
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>Total Cost ($)</FieldLabel>

                            <Input
                              disableUnderline
                              disabled
                              className="ai-input ai-input--disabled"
                              value={state.total_cost || "0.00"}
                            />
                          </FormControl>
                        )}
                      </>
                    )}
                  </SectionCard>
                  {/* Misc watch and Misc Product Purchase Details */}
                  {(state.InventoryType === "misc-watch" || MISC_PRODUCT_TYPES.includes(state.InventoryType)) && (
                    <SectionCard
                      icon={<TuneOutlinedIcon />}
                      title="PURCHASE DETAILS"
                      style={{ marginTop: "10px" }}
                    >
                      {(isActionAllowed(state.viewData, "purchase_from") ||
                        isActionAllowed(state.viewData, "purchase_date")) && (
                          <Grid container spacing={2}>

                            {isActionAllowed(state.viewData, "purchase_from") && (
                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>Purchased From</FieldLabel>

                                  <div className="ai-input-icon-wrap">
                                    <AntdInput
                                      id="PurchasedFrom"
                                      type="text"
                                      autoComplete="off"
                                      className="ai-antd-input"
                                      placeholder="Search dealer or source"
                                      value={state.PurchasedFrom}
                                      onChange={(e) =>
                                        onchangeContactSuggestion(
                                          e,
                                          "PurchasedFrom",
                                          ["supplier", "memo_supplier"]
                                        )
                                      }
                                      bordered={false}
                                    />

                                    <span className="ai-input-icon-wrap__icon">
                                      {!state.PurchasedFrom ? (
                                        <SearchIcon
                                          style={{ cursor: "pointer" }}
                                          fontSize="small"
                                        />
                                      ) : state.fieldLoader ? (
                                        <CircularProgress
                                          style={{
                                            width: 18,
                                            height: 18,
                                          }}
                                        />
                                      ) : (
                                        <ClearIcon
                                          id="clearBtn"
                                          onClick={() =>
                                            clearContactSuggestion("PurchasedFrom")
                                          }
                                          style={{ cursor: "pointer" }}
                                          fontSize="small"
                                        />
                                      )}
                                    </span>
                                  </div>

                                  {state.purchasedFromArray &&
                                    state.purchasedFromArray.length > 0 &&
                                    state.PurchasedFrom?.length > 0 ? (
                                    <AntdPopover
                                      visible={state.isPopOverPurchasedFrom}
                                      content={
                                        <div
                                          style={{
                                            height: "200px",
                                            overflow: "auto",
                                          }}
                                        >
                                          {state.dataset?.slice(0, 15).map((value, key) =>
                                            value.map((el, index) => {
                                              if (index < 1) {
                                                return (
                                                  <React.Fragment key={index}>
                                                    {state.purchasedFromArray
                                                      ?.filter(
                                                        (v) => v.email == el.email
                                                      )
                                                      .map((el, index) => (
                                                        <AccordionDetails key={index}>
                                                          <Typography
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              handleContactSelection(
                                                                el,
                                                                "PurchasedFrom"
                                                              )
                                                            }
                                                          >
                                                            {handleContact(el)}
                                                          </Typography>
                                                        </AccordionDetails>
                                                      ))}
                                                  </React.Fragment>
                                                );
                                              }

                                              return null;
                                            })
                                          )}
                                        </div>
                                      }
                                      trigger="click"
                                      placement="bottomRight"
                                      onVisibleChange={handleVisibleChange}
                                    >
                                      <div
                                        style={{
                                          width: 0,
                                          height: 0,
                                          position: "absolute",
                                        }}
                                      />
                                    </AntdPopover>
                                  ) : (
                                    state.PurchasedFrom?.length > 2 &&
                                    !state.purchasedFromArray?.length &&
                                    !state.fieldLoader && (
                                      <AntdPopover
                                        visible={
                                          state.PurchasedFrom?.length > 2 &&
                                          !state.purchasedFromArray?.length &&
                                          !state.fieldLoader
                                        }
                                        content={
                                          <div style={{ overflow: "auto" }}>
                                            <a
                                              className="dataItem"
                                              href="javascript:void(0)"
                                              onClick={() => {
                                                const typeData = [
                                                  {
                                                    id: "supplier",
                                                    value: "Supplier",
                                                  },
                                                  {
                                                    id: "memo_supplier",
                                                    value: "Memo Supplier",
                                                  },
                                                ];

                                                const encodedTypeData = btoa(
                                                  JSON.stringify(typeData)
                                                );

                                                window.open(
                                                  `/contactmanagement/add?type=${encodedTypeData}`,
                                                  "_blank"
                                                );
                                              }}
                                              style={{
                                                cursor: "pointer",
                                                textDecoration: "underline",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Click here to Create New Contact
                                            </a>
                                          </div>
                                        }
                                        trigger="click"
                                        placement="bottomRight"
                                        overlayStyle={{
                                          marginTop: "5px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: 0,
                                            height: 0,
                                            position: "absolute",
                                          }}
                                        />
                                      </AntdPopover>
                                    )
                                  )}
                                </FormControl>
                              </Grid>
                            )}

                            {isActionAllowed(state.viewData, "purchase_date") && (
                              <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className="ai-field">
                                  <FieldLabel>Purchased Date</FieldLabel>

                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                      className="ai-datepicker"
                                      margin="normal"
                                      id="date-picker-purchased-date"
                                      format="MM/dd/yyyy"
                                      disableFuture
                                      value={state.PurchasedDate || null}
                                      onChange={handleDateChange}
                                      KeyboardButtonProps={{
                                        "aria-label": "change date",
                                      }}
                                      placeholder="MM/DD/YYYY"
                                      onPaste={(event) => event.preventDefault()}
                                      helperText={
                                        state.error["PD"] ? "Invalid date" : ""
                                      }
                                      error={state.error["PD"]}
                                    />
                                  </MuiPickersUtilsProvider>

                                  <FormHelperText className="error-o">
                                    {state.onPurchasedDateErrorText}
                                  </FormHelperText>
                                </FormControl>
                              </Grid>
                            )}
                          </Grid>
                        )}

                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>Purchase Payment Status</FieldLabel>

                            <Select
                              disableUnderline
                              className="ai-select"
                              value={state.paidStatus ? "paid" : "unpaid"}
                              onChange={(e) =>
                                handlePaidStatusCheck({
                                  target: {
                                    checked: e.target.value === "paid",
                                  },
                                })
                              }
                              renderValue={(val) => (
                                <span className="ai-status-pill">
                                  <span className="ai-status-pill__dot" />
                                  {val === "paid" ? "Paid" : "Unpaid"}
                                </span>
                              )}
                            >
                              <MenuItem value="paid">Paid</MenuItem>
                              <MenuItem value="unpaid">Unpaid</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>
                              {state.paidStatus
                                ? "Purchase Payment Date"
                                : "Purchase Payment Due Date"}
                            </FieldLabel>

                            {state.paidStatus ? (
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  key="paid-date-picker"
                                  className="ai-datepicker"
                                  margin="normal"
                                  id="date-picker-purchase"
                                  format="MM/dd/yyyy"
                                  disableFuture
                                  value={state.paymentDate || null}
                                  onChange={handlePayDateChange}
                                  KeyboardButtonProps={{
                                    "aria-label": "change date",
                                  }}
                                  placeholder="MM/DD/YYYY"
                                  onPaste={(event) => event.preventDefault()}
                                  helperText={
                                    state.error["PPD"] ? "Invalid date" : ""
                                  }
                                  error={state.error["PPD"]}
                                />
                              </MuiPickersUtilsProvider>
                            ) : (
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  key="due-date-picker"
                                  className="ai-datepicker"
                                  margin="normal"
                                  id="date-picker-dialog"
                                  format="MM/dd/yyyy"
                                  value={state.purchaseDueDate || null}
                                  onChange={handleDueDateChange}
                                  KeyboardButtonProps={{
                                    "aria-label": "change date",
                                  }}
                                  placeholder="MM/DD/YYYY"
                                  onPaste={(event) => event.preventDefault()}
                                  helperText={
                                    state.error["PPDD"] ? "Invalid date" : ""
                                  }
                                  error={state.error["PPDD"]}
                                />
                              </MuiPickersUtilsProvider>
                            )}

                            <FormHelperText className="error-o">
                              {state.onpaymentDateErrorText}
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                      </Grid>

                      <FormControl fullWidth className="ai-field">
                        <FieldLabel>Purchase Payment Details</FieldLabel>

                        <Input
                          disableUnderline
                          className="ai-input ai-input--textarea"
                          placeholder="Enter payment details"
                          multiline
                          onChange={onchangePaymentDetails}
                          value={state.PaymentDetailsText || ""}
                        />

                        <FormHelperText className="error-o">
                          {state.onPaymentDetailsErrorText}
                        </FormHelperText>
                      </FormControl>

                      <Grid container spacing={2}>
                        {isActionAllowed(state.viewData, "purchase_price") && (
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>Purchased Price ($)</FieldLabel>

                              <Input
                                disableUnderline
                                className="ai-input"
                                placeholder="0.00"
                                onChange={onchangePurchasedPrice}
                                value={state.PurchasedPrice}
                              />

                              <FormHelperText className="error-o">
                                {state.onPurchasedPriceErrorText}
                              </FormHelperText>
                            </FormControl>
                          </Grid>
                        )}

                        {isActionAllowed(state.viewData, "purchase_expense") && (
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>Purchase Expense ($)</FieldLabel>

                              <Input
                                disableUnderline
                                className="ai-input"
                                placeholder="0.00"
                                onChange={onchangePurchaseExpense}
                                value={state.purchase_expense}
                              />
                            </FormControl>
                          </Grid>
                        )}
                      </Grid>

                      {isActionAllowed(state.viewData, "purchase_expense") && (
                        <FormControl fullWidth className="ai-field">
                          <FieldLabel>Purchase Expense Note</FieldLabel>

                          <Input
                            disableUnderline
                            className="ai-input"
                            placeholder="Enter expense note"
                            onChange={onchangePurchaseExpenseNote}
                          />
                        </FormControl>
                      )}

                      <Grid container spacing={2}>
                        {isActionAllowed(state.viewData, "total_cost") && (
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>Total Cost ($)</FieldLabel>

                              <Input
                                disableUnderline
                                disabled
                                className="ai-input ai-input--disabled"
                                value={state.total_cost || "0.00"}
                              />
                            </FormControl>
                          </Grid>
                        )}
                      </Grid>
                    </SectionCard>
                  )}

                  <SectionCard
                    icon={<TuneOutlinedIcon />}
                    title="INVENTORY DETAILS" style={{ marginTop: "10px" }}
                  >
                    <Grid container spacing={2}>
                      {/* Misc watch serial number */}
                      {state.InventoryType === "misc-watch" && (
                        <FormControl fullWidth className="ai-field">
                          <FieldLabel>Serial Number</FieldLabel>
                          <Input
                            disableUnderline
                            className="ai-input"
                            placeholder="Enter serial number"
                            id="serialNumberMisc"
                            onChange={onchangeSerialNumberMisc}
                            value={state.SerialNumberMisc || ""}
                          />

                          <FormHelperText className="error-o">
                            {state.onSerialNumberMiscErrorText}
                          </FormHelperText>
                        </FormControl>
                      )}
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>Inventory Type</FieldLabel>
                            <Select
                              displayEmpty
                              className="ai-select"
                              value={state.inventory_type || ""}
                              onChange={onchangeInventoryType}
                            >
                              <MenuItem value="" disabled>Select Type</MenuItem>
                              <MenuItem value="1">Regular Inventory</MenuItem>
                              <MenuItem value="2">Memo Inventory</MenuItem>
                              <MenuItem value="3">Partnership Inventory</MenuItem>
                              <MenuItem value="5">Consignment Inventory</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>

                        {state.inventory_type === "2" && (
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>Memo Contact</FieldLabel>
                              <div className="ai-input-icon-wrap">
                                <AntdInput
                                  id="MemoDetails"
                                  type="text"
                                  autoComplete="off"
                                  className="ai-antd-input"
                                  value={state.MemoDetails}
                                  placeholder="Search Memo Contact Name / Business Name"
                                  onChange={(e) => onchangeContactSuggestion(e, "MemoDetails", ["memo_supplier"])}
                                  bordered={false}
                                />
                                <span className="ai-input-icon-wrap__icon">
                                  {!state.MemoDetails ? (
                                    <SearchIcon fontSize="small" style={{ cursor: "pointer" }} />
                                  ) : state.fieldLoader ? (
                                    <CircularProgress style={{ width: 18, height: 18 }} />
                                  ) : (
                                    <ClearIcon
                                      fontSize="small"
                                      onClick={() => clearContactSuggestion("MemoDetails")}
                                      style={{ cursor: "pointer" }}
                                    />
                                  )}
                                </span>
                              </div>
                              {state.memoDetailsArray && state.memoDetailsArray.length > 0 && state.MemoDetails?.length > 0 ? (
                                <AntdPopover
                                  visible={state.isPopOverMemoDetails}
                                  content={
                                    <div style={{ height: "200px", overflow: "auto" }}>
                                      {state.dataset?.slice(0, 15).map((value, key) => {
                                        return value.map((el, index) => {
                                          if (index < 1) {
                                            return (
                                              <React.Fragment key={index}>
                                                {state.memoDetailsArray
                                                  ?.filter((v) => v.email == el.email)
                                                  .map((el, index) => (
                                                    <AccordionDetails key={index}>
                                                      <Typography
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => handleContactSelection(el, "MemoDetails")}
                                                      >
                                                        {handleContact(el)}
                                                      </Typography>
                                                    </AccordionDetails>
                                                  ))}
                                              </React.Fragment>
                                            );
                                          }
                                        });
                                      })}
                                    </div>
                                  }
                                  trigger="click"
                                  placement="bottomRight"
                                  onVisibleChange={handleVisibleChange}
                                >
                                  <div style={{ width: 0, height: 0, position: "absolute" }} />
                                </AntdPopover>
                              ) : (
                                state.MemoDetails?.length > 2 &&
                                !state.memoDetailsArray.length &&
                                !state.fieldLoader && (
                                  <AntdPopover
                                    visible={
                                      state.MemoDetails?.length > 2 && !state.memoDetailsArray.length && !state.fieldLoader
                                    }
                                    content={
                                      <div style={{ overflow: "auto" }}>
                                        <a
                                          className="dataItem"
                                          onClick={() => {
                                            const typeData = [{ id: "memo_supplier", value: "Memo Supplier" }];
                                            const encodedTypeData = btoa(JSON.stringify(typeData));
                                            window.open(`/contactmanagement/add?type=${encodedTypeData}`, "_blank");
                                          }}
                                          style={{ cursor: "pointer", textDecoration: "underline", fontWeight: "bold" }}
                                        >
                                          Click here to Create New Contact
                                        </a>
                                      </div>
                                    }
                                    trigger="click"
                                    placement="bottomRight"
                                    overlayStyle={{ marginTop: "5px" }}
                                  >
                                    <div style={{ width: 0, height: 0, position: "absolute" }} />
                                  </AntdPopover>
                                )
                              )}
                            </FormControl>
                          </Grid>
                        )}

                        {state.inventory_type === "3" && (
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>Partnership Contact</FieldLabel>
                              <div className="ai-input-icon-wrap">
                                <AntdInput
                                  id="PartnershipDetails"
                                  type="text"
                                  autoComplete="off"
                                  className="ai-antd-input"
                                  value={state.PartnershipDetails}
                                  placeholder="Search Partnership Contact / Business Name"
                                  onChange={(e) => onchangeContactSuggestion(e, "PartnershipDetails", ["partner"])}
                                  bordered={false}
                                />
                                <span className="ai-input-icon-wrap__icon">
                                  {!state.PartnershipDetails ? (
                                    <SearchIcon fontSize="small" style={{ cursor: "pointer" }} />
                                  ) : state.fieldLoader ? (
                                    <CircularProgress style={{ width: 18, height: 18 }} />
                                  ) : (
                                    <ClearIcon
                                      fontSize="small"
                                      onClick={() => clearContactSuggestion("PartnershipDetails")}
                                      style={{ cursor: "pointer" }}
                                    />
                                  )}
                                </span>
                              </div>
                              {state.partnershipDetailsArray &&
                                state.partnershipDetailsArray.length > 0 &&
                                state.PartnershipDetails?.length > 0 ? (
                                <AntdPopover
                                  visible={state.isPopOverPartnershipDetails}
                                  content={
                                    <div style={{ height: "200px", overflow: "auto" }}>
                                      {state.dataset?.slice(0, 15).map((value, key) => {
                                        return value.map((el, index) => {
                                          if (index < 1) {
                                            return (
                                              <React.Fragment key={index}>
                                                {state.partnershipDetailsArray
                                                  ?.filter((v) => v.email == el.email)
                                                  .map((el, index) => (
                                                    <AccordionDetails key={index}>
                                                      <Typography
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => handleContactSelection(el, "PartnershipDetails")}
                                                      >
                                                        {handleContact(el)}
                                                      </Typography>
                                                    </AccordionDetails>
                                                  ))}
                                              </React.Fragment>
                                            );
                                          }
                                        });
                                      })}
                                    </div>
                                  }
                                  trigger="click"
                                  placement="bottomRight"
                                  onVisibleChange={handleVisibleChange}
                                >
                                  <div style={{ width: 0, height: 0, position: "absolute" }} />
                                </AntdPopover>
                              ) : (
                                state.PartnershipDetails.length > 2 &&
                                !state.partnershipDetailsArray.length &&
                                !state.fieldLoader && (
                                  <AntdPopover
                                    visible={
                                      state.PartnershipDetails?.length > 2 &&
                                      !state.partnershipDetailsArray.length &&
                                      !state.fieldLoader
                                    }
                                    content={
                                      <div style={{ overflow: "auto" }}>
                                        <a
                                          className="dataItem"
                                          href="javascript:void(0)"
                                          onClick={() => {
                                            const typeData = [{ id: "partner", value: "Partner" }];
                                            const encodedTypeData = btoa(JSON.stringify(typeData));
                                            window.open(`/contactmanagement/add?type=${encodedTypeData}`, "_blank");
                                          }}
                                          style={{ cursor: "pointer", textDecoration: "underline", fontWeight: "bold" }}
                                        >
                                          Click here to Create New Contact
                                        </a>
                                      </div>
                                    }
                                    trigger="click"
                                    placement="bottomRight"
                                    overlayStyle={{ marginTop: "5px" }}
                                  >
                                    <div style={{ width: 0, height: 0, position: "absolute" }} />
                                  </AntdPopover>
                                )
                              )}
                            </FormControl>
                          </Grid>
                        )}

                        {(state.inventory_type === "2" || state.inventory_type === "3") && (
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>{state.inventory_type === "2" ? "Memo Number" : "Partnership Number"}</FieldLabel>
                              <Input
                                disableUnderline
                                placeholder={
                                  state.inventory_type === "2"
                                    ? "Enter Memo Number"
                                    : "Enter Partnership Number"
                                }
                                className="ai-input"
                                onChange={(e) => {
                                  setState({
                                    updatememo: state.inventory_type === "2" ? e.target.value : null,
                                    updatepartnershipnumber: state.inventory_type === "3" ? e.target.value : null,
                                  });
                                }}
                              />
                            </FormControl>
                          </Grid>
                        )}
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field">
                            <FieldLabel>Inventory Status</FieldLabel>
                            <Select
                              displayEmpty
                              className="ai-select"
                              value={state.inventory_status || ""}
                              onChange={onchangeInventoryStatus}
                            >
                              <MenuItem value="" disabled>
                                Select status
                              </MenuItem>
                              <MenuItem value="2">Incoming</MenuItem>
                              <MenuItem value="6">Needs Service / Polish</MenuItem>
                              <MenuItem value="7">At Service</MenuItem>
                              <MenuItem value="11">Intake Complete</MenuItem>
                              <MenuItem value="13">Need to Post</MenuItem>
                              <MenuItem value="12">Invoiced</MenuItem>
                              <MenuItem value="1">Inhand</MenuItem>
                              <MenuItem value="3">Out on Memo</MenuItem>
                              <MenuItem value="4">On Hold / Reserved</MenuItem>
                              <MenuItem value="8">Need to Ship</MenuItem>
                              <MenuItem value="9">
                                Shipped waiting on payment
                              </MenuItem>
                              <MenuItem value="10">Sold &amp; Cashed Out</MenuItem>
                              <MenuItem value="5">Available to Order</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth className="ai-field ai-field--dropdown">
                            <FieldLabel>Inventory Location</FieldLabel>
                            <Input
                              disableUnderline
                              className="ai-input"
                              placeholder="Enter location"
                              id="autocomplete1"
                              onChange={locationAutoComplete}
                              onFocus={handleLocationFocus}
                              onBlur={handleLocationBlur}
                              value={state.locationSearch}
                              endAdornment={
                                state.locationloading ? (
                                  <InputAdornment position="end">
                                    <CircularProgress size={16} />
                                  </InputAdornment>
                                ) : null
                              }
                            />
                            {!state.locationloading && state.locationAutoCompleteData?.data?.length > 0 ? (
                              <List
                                className="searchlist MuiPaper-elevation1 inventrysearch ai-location-results"
                                style={{ listStyle: "none" }}
                              >
                                {state.locationAutoCompleteData.data.map(
                                  (item, idx) => (
                                    <div key={idx}>
                                      <ListItem
                                        className={
                                          cursor === idx ? "active" : ""
                                        }
                                        style={{ cursor: "pointer" }}
                                        onMouseDown={() =>
                                          onchangeLocation(item)
                                        }
                                      >
                                        <ListItemText
                                          primary={item.locations}
                                          style={{
                                            marginTop: "10px",
                                            marginLeft: "50px",
                                          }}
                                        />
                                      </ListItem>

                                      <Divider
                                        variant="inset"
                                        component="li"
                                        style={{ margin: "5px" }}
                                      />
                                    </div>
                                  )
                                )}
                              </List>
                            ) : null}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          {!MISC_PRODUCT_TYPES.includes(state.InventoryType) && (
                            <FormControl fullWidth className="ai-field">
                              <FieldLabel>Band Size</FieldLabel>
                              <Input
                                disableUnderline
                                className="ai-input"
                                placeholder="Enter band size"
                                value={state.BandSize || ""}
                                onChange={(e) =>
                                  onchangeBandSize({
                                    target: {
                                      value: e.target.value,
                                    },
                                  })
                                }
                              />
                              <FormHelperText className="error-o">
                                {state.onBandSizeErrorText}
                              </FormHelperText>
                            </FormControl>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                    {!MISC_PRODUCT_TYPES.includes(state.InventoryType) && (
                      <div className="ai-condition" id="conditionField">
                        <FieldLabel>Condition</FieldLabel>
                        <ConditionSelector
                          marks={followersMarks1()}
                          value={state.Condition}
                          onChange={onchangeCondition}
                        />
                        <div className="ai-condition-hint">
                          <InfoOutlinedIcon style={{ fontSize: 14 }} />
                          Select the condition that best describes your inventory.
                        </div>

                        <FormHelperText className="error-o">
                          {state.onConditionErrorText}
                        </FormHelperText>
                      </div>
                    )}
                    {MISC_PRODUCT_TYPES.includes(state.InventoryType) && (
                      <div className="ai-condition" id="conditionField">
                        <FieldLabel>Condition</FieldLabel>
                        <ConditionSelector
                          marks={followersMarks2()}
                          value={state.Condition}
                          onChange={onchangeCondition}
                        />
                        <div className="ai-condition-hint">
                          <InfoOutlinedIcon style={{ fontSize: 14 }} />
                          Select the condition that best describes your inventory.
                        </div>

                        <FormHelperText className="error-o">
                          {state.onConditionErrorText}
                        </FormHelperText>
                      </div>
                    )}
                  </SectionCard>

                </div>
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <div className="ai-col">
                  <SectionCard icon={<DescriptionOutlinedIcon />} title="SPECIFICATIONS & PRICING">
                    {!MISC_PRODUCT_TYPES.includes(state.InventoryType) && (
                      <FormControl fullWidth className="ai-field">
                        <FieldLabel>Number of Links / Screws</FieldLabel>
                        <Input
                          disableUnderline
                          className="ai-input"
                          placeholder="Enter number"
                          onChange={onchangeNumberOfLinks}
                          value={state.NumberOfLinks}
                        />
                        <FormHelperText className="error-o">{state.onNumberOfLinksErrorText}</FormHelperText>
                      </FormControl>
                    )}

                    <FormControl fullWidth className="ai-field">
                      <FieldLabel>Internal Dealer Note</FieldLabel>
                      <Input
                        disableUnderline
                        multiline
                        className="ai-input ai-input--textarea ai-input--textarea-lg"
                        placeholder="Enter internal note"
                        onChange={onchangeDealerNotes}
                      />
                      <FormHelperText className="error-o">{state.onDealerNotesErrorText}</FormHelperText>
                    </FormControl>

                    <FormControl fullWidth className="ai-field">
                      <FieldLabel>Public Dealer Notes</FieldLabel>
                      <Input
                        disableUnderline
                        multiline
                        className="ai-input ai-input--textarea ai-input--textarea-lg"
                        placeholder="Enter public notes"
                        onChange={onchangePublicDealerNote}
                      />
                    </FormControl>
                  </SectionCard>

                  <SectionCard icon={<PaidOutlinedIcon />} title="TARGET PRICING DETAILS" style={{ marginTop: "10px" }}>
                    <FormControl fullWidth className="ai-field">
                      <FieldLabel>{getCustomLabel("custom_wholesale_price", "Target Wholesale Price")} ($)</FieldLabel>
                      <Input
                        disableUnderline
                        className="ai-input"
                        placeholder="0.00"
                        onChange={onchangeWholeSalePrice}
                        value={state.WholeSalePrice}
                      />
                      <FormHelperText className="error-o">{state.onWholeSalePriceErrorText}</FormHelperText>
                    </FormControl>

                    <FormControl fullWidth className="ai-field">
                      <FieldLabel>{getCustomLabel("custom_end_customer_price", "Target End Customer Price")} ($)</FieldLabel>
                      <Input
                        disableUnderline
                        className="ai-input"
                        placeholder="0.00"
                        onChange={onchangeRetailPrice}
                        value={state.RetailPrice}
                      />
                      <FormHelperText className="error-o">{state.onRetailPriceErrorText}</FormHelperText>
                    </FormControl>

                    <FormControl fullWidth className="ai-field">
                      <FieldLabel>
                        {getCustomLabel("custom_end_customer_wire_price", "Target End Customer Wire Price")} ($)
                      </FieldLabel>
                      <Input
                        disableUnderline
                        className="ai-input"
                        placeholder="0.00"
                        onChange={onchangeRetailWirePrice}
                        value={state.RetailWirePrice}
                      />
                      <FormHelperText className="error-o">{state.onRetailWirePriceErrorText}</FormHelperText>
                    </FormControl>

                    <FormControl fullWidth className="ai-field">
                      <FieldLabel>{getCustomLabel("custom_tag_price", "Tag Price")} ($)</FieldLabel>
                      <Input
                        disableUnderline
                        className="ai-input"
                        placeholder="0.00"
                        onChange={onchangeTagPrice}
                        value={state.tag_price ? state.tag_price : ""}
                      />
                      <FormHelperText className="error-o">{state.onTagPriceErrorText}</FormHelperText>
                    </FormControl>
                  </SectionCard>

                  <SectionCard icon={<InsertDriveFileOutlinedIcon />} title="INVOICE FILE" style={{ marginTop: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <Typography className="ai-uploads__col-title">Invoice Images or File</Typography>
                      <Tooltip title="Please attach images separately as high resolution JPG/PNG/JPEG/GIF/PDF/DOC/DOCX">
                        <span>
                          <HelpIcon fontSize="small" style={{ color: "#CEA05F" }} />
                        </span>
                      </Tooltip>
                    </div>
                    {state.invoiceFiles.length > 0 ? (
                      <InvoiceFilePreviewCard
                        file={state.invoiceFiles[0]}
                        inputId="ai-upload-invoice"
                        accept="image/*,application/pdf,.doc,.docx,application/msword,.gif"
                        onReplace={handleInvoiceFilesSelected}
                        onRemove={removeInvoiceFile}
                      />
                    ) : (
                      <UploadDropzone
                        inputId="ai-upload-invoice"
                        icon={<InsertDriveFileOutlinedIcon />}
                        title="Click to upload or drag & drop"
                        hint="JPG, PNG, JPEG, PDF, DOC, DOCX, GIF"
                        accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx"
                        multiple={false}
                        onFilesSelected={handleInvoiceFilesSelected}
                      />
                    )}
                  </SectionCard>

                  <SectionCard icon={<WarningAmberOutlinedIcon />} title="ADDITIONAL OPTIONS" style={{ marginTop: "10px" }}>
                    {!MISC_PRODUCT_TYPES.includes(state.InventoryType) && (
                      <>
                        <FormControlLabel
                          control={<Checkbox className="ai-checkbox" onClick={handleCheck1} />}
                          label="I have a box"
                        />

                        {/* <div className="ai-subgroup"> */}
                        <p className="ai-subgroup__title">Type of Paper</p>
                        <div className="ai-checkbox-inline">
                          <FormControlLabel
                            control={<Checkbox className="ai-checkbox" value="Warranty" onChange={handleTypeOfPaperCheck} />}
                            label="Warranty"
                          />
                          <FormControlLabel
                            control={<Checkbox className="ai-checkbox" value="Archive" onChange={handleTypeOfPaperCheck} />}
                            label="Archive"
                          />
                          <FormControlLabel
                            control={<Checkbox className="ai-checkbox" value="isService" onChange={handleTypeOfPaperCheck} />}
                            label="Service Card/Paper"
                          />
                        </div>
                        {state.warrentyExpiryDate && (

                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <FieldLabel>Warranty Expiry Date</FieldLabel>
                            <KeyboardDatePicker
                              className="ai-datepicker"
                              margin="normal"
                              id="date-picker-dialog"
                              format="MM/dd/yyyy"
                              value={state.PurchasedDate1 || null}
                              onChange={(date, e) => handleDateChange1(date, e, "Warranty")}
                              KeyboardButtonProps={{ "aria-label": "change date" }}
                              style={{ marginBottom: "20px", marginTop: "0px" }}
                              helperText={state.error["Warranty"] ? "Invalid date" : ""}
                              error={state.error["Warranty"]}
                              placeholder="Warranty - MM/DD/YYYY"
                              onPaste={(event) => event.preventDefault()}
                            />
                          </MuiPickersUtilsProvider>
                        )}&emsp;
                        {state.archivePaperSet && (
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <FieldLabel>Archive Date</FieldLabel>
                            <KeyboardDatePicker
                              className="ai-datepicker"
                              margin="normal"
                              id="date-picker-dialog"
                              format="MM/dd/yyyy"
                              value={state.archiveDate || null}
                              onChange={(date, e) => handleDateChange1(date, e, "Archive")}
                              KeyboardButtonProps={{ "aria-label": "change date" }}
                              style={{ marginBottom: "20px", marginTop: "0px" }}
                              helperText={state.error["Archive"] ? "Invalid date" : ""}
                              error={state.error["Archive"]}
                              placeholder="Archive - MM/DD/YYYY"
                              onPaste={(event) => event.preventDefault()}
                            />
                          </MuiPickersUtilsProvider>
                        )}
                        {state.isService && (
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <FieldLabel>Service Card / Paper Date</FieldLabel>
                            <KeyboardDatePicker
                              className="ai-datepicker"
                              margin="normal"
                              id="date-picker-dialog"
                              format="MM/dd/yyyy"
                              value={state.serviceDate || null}
                              onChange={(date, e) => handleDateChange1(date, e, "Service")}
                              KeyboardButtonProps={{ "aria-label": "change date" }}
                              style={{ marginBottom: "20px", marginTop: "0px" }}
                              helperText={state.error["Service"] ? "Invalid date" : ""}
                              error={state.error["Service"]}
                              placeholder="Service Card / Paper - MM/DD/YYYY"
                              onPaste={(event) => event.preventDefault()}
                            />
                          </MuiPickersUtilsProvider>
                        )}
                        {/* </div> */}

                        <div className="ai-subgroup">
                          <p className="ai-subgroup__title">Modification</p>
                          <FormControlLabel
                            control={<Checkbox className="ai-checkbox" value={state.ismodified} onChange={handleCheck2} />}
                            label="Modified"
                          />
                          {state.ismodified && (
                            <FormControl fullWidth className="ai-field">
                              <FieldLabel className="ai-field__label">
                                Modification Details
                              </FieldLabel>
                              <Input
                                disableUnderline
                                id="modificationDetails"
                                className="ai-input ai-input--textarea"
                                value={state.modification_deatils}
                                onChange={onchangeModificationDetails}
                                placeholder="Enter modification details"
                                multiline
                                maxRows={4}
                              />
                              <FormHelperText className="error-o">{state.modificationDetailsError}</FormHelperText>
                            </FormControl>
                          )}
                        </div>
                      </>
                    )}

                    {state.userData &&
                      (state.userData.dealerInventorySubscription === "access_only" ||
                        state.userData.dealerInventorySubscription === "no_subscription") ? null : (
                      <div className="ai-subgroup">
                        <p className="ai-subgroup__title">Dealer Feed</p>
                        <FormControlLabel
                          control={<Checkbox className="ai-checkbox" checked={state.dealerInv} onChange={handleInclude} />}
                          label="Include in the Dealer Feed"
                        />
                      </div>
                    )}

                    {state.isShopifyEnabled && state.isShopifyVerified ? (
                      <div className="ai-subgroup">
                        <FieldLabel className="ai-subgroup__title">Shopify Configuration</FieldLabel>
                        <FormControlLabel
                          control={
                            <Checkbox className="ai-checkbox" checked={state.shopifyConfig} onChange={handleIncludeShopify} />
                          }
                          label="Include in the Shopify"
                        />
                      </div>
                    ) : null}

                    {state.isQboVerified ? (
                      <div className="ai-subgroup">
                        <p className="ai-subgroup__title">QuickBook Configuration</p>
                        <FormControlLabel
                          control={<Checkbox className="ai-checkbox" checked={state.qboConfig} onChange={handleIncludeQbo} />}
                          label="Include in the Quickbook"
                        />
                      </div>
                    ) : null}

                    {state.isEbayVerified ? (
                      <div className="ai-subgroup">
                        <p className="ai-subgroup__title">Ebay Configuration</p>
                        <FormControlLabel
                          control={<Checkbox className="ai-checkbox" checked={state.ebayConfig} onChange={handleIncludeEbay} />}
                          label="Include in the Ebay"
                        />
                      </div>
                    ) : null}
                  </SectionCard>
                </div>
              </Grid>

              <Grid item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }}>
                <SectionCard icon={<CloudUploadOutlinedIcon />} title="UPLOADS (IMAGES & VIDEOS)">
                  <Typography className="ai-uploads__hint">
                    Upload related images and videos of the watch.
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography className="ai-uploads__col-title">IMAGES</Typography>
                      <UploadDropzone
                        inputId="ai-upload-images"
                        icon={<ImageOutlinedIcon />}
                        title="Click to upload or drag & drop"
                        hint="JPG, PNG"
                        accept="image/*"
                        onFilesSelected={handleImagesSelected}
                      />
                      <ImagePreviewGrid files={state.imageFiles} onRemove={removeImageFile} />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography className="ai-uploads__col-title">VIDEOS</Typography>
                      <UploadDropzone
                        inputId="ai-upload-videos"
                        icon={<VideocamOutlinedIcon />}
                        title="Click to upload or drag & drop"
                        hint="MP4, MOV"
                        accept="video/*"
                        onFilesSelected={handleVideosSelected}
                      />
                      <VideoPreviewGrid files={state.videoFiles} onRemove={removeVideoFile} />
                    </Grid>
                  </Grid>
                </SectionCard>
              </Grid>
            </Grid>

            <div className="ai-bottombar">
              <Button className="ai-btn ai-btn--ghost" onClick={backNavigation}>
                Cancel
              </Button>
              <Button
                type="submit"
                className="ai-btn ai-btn--primary"
                disabled={state.isSubmitting}
              // onClick={validateInput}
              >
                Save Inventory
                {state.isSubmitting && (
                  <CircularProgress color="inherit" style={{ width: 16, height: 16, marginLeft: 8 }} />
                )}
              </Button>
            </div>
          </Container>
          {state.limitReachedModalOpen && (
            <LimitReachedComponent
              isOpen={state.limitReachedModalOpen}
              onClose={closeLimitReachedModal}
              keyword="Product search"
            />
          )}
        </form>
      )}
      <br />
      <br />
    </div>
  );

  return (
    <ContentWrapper>
      {state.userData &&
      (!state.userData?.planDetails || state.userData?.planDetails === "Noplan") ? (
        <div style={{ marginTop: "25px" }}>
          <UpgradePlan />
        </div>
      ) : isActionAllowed(state.accessData, "add_inventory") ? (
        inventoryPage()
      ) : (
        <AccessRestricted />
      )}
    </ContentWrapper>
  );
}

function mapStateToProps({ individualBrowseWatchesInfo, auth, dealer, browseWatchesInfo }) {
  localStorage.setItem("menuTitle", "ADD INVENTORY");
  return {
    individualBrowseWatchesInfo: individualBrowseWatchesInfo.individualBrowseWatchesInfo,
    currentUser: auth.currentUser,
    autocompleteProducts: dealer.autoCompleteProducts,
    brandInfo: browseWatchesInfo.brandInfo,
    caseMaterialInfo: browseWatchesInfo.caseMaterialInfo,
    brandMaterialInfo: browseWatchesInfo.brandMaterialInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addInventoryData,
      addMiscInventoryData,
      individualBrowseWatch,
      searchProducts,
      brandList,
      caseMaterial,
      brandMaterial,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DealerProductInventoryIntakeComponent);